import jsonLogic from 'json-logic-js';
import store from '@/store';
import moment from 'moment';
import CommonService from '@/_core/service/commonService';
import urlObj from '@/../_config/_app/apiConfiguration.json';
import pageBasedOnProducts from '@/../_config/_app/pageConfigBasedOnProduct.json';
import appSettings from '@/plugins/appSettings';

const formDataMixin = {
  methods: {
    async reviewInfo(arg2) {
      const productMapping = store?.getters['userStore/userData']?.productInfo;
      const response = store.getters['userStore/userData']?.personalInformationData;
      const personalInfoResponse = response && response.data ? response.data : response;
      const personalInformation = JSON.parse(personalInfoResponse.personalInformation);
      // const contactInformation = JSON.parse(personalInfoResponse?.contactInformation);
      const otherInformation = JSON.parse(personalInfoResponse?.otherInformation);
      const productInformation = JSON.parse(personalInfoResponse?.productInformation);
      const bankAccount = this.formInput && this.formInput.data && this.formInput.data[this.additionalInformationPage] && this.formInput.data[this.additionalInformationPage]?.bankAccount &&

      this.formInput.data[this.additionalInformationPage]?.bankAccount !== '' ? this.formInput.data[this.additionalInformationPage]?.bankAccount
        : this.formInput.data[this.additionalInformationPage]?.iban !== undefined && this.formInput.data[this.additionalInformationPage]?.iban !== ''
          ? 'true' : this.formInput.data[this.additionalInformationPage]?.accountNumber !== undefined &&
      this.formInput.data[this.additionalInformationPage]?.accountNumber !== '' ? 'false' : 'false';

      if (arg2 !== 'saveExit' && this.formInput.data[this.additionalInformationPage]?.expectedTurnover !== undefined && this.formInput.data[this.additionalInformationPage]?.expectedTurnover !== '' && !(/^\d+(\.\d{1,2})?$/.test(this.formInput.data[this.additionalInformationPage]?.expectedTurnover))) {
        this.displaySnackBar({ title: `${this.$t('messages.error')}`, content: this.$t('messages.save.invalidFormatError'), type: 'error' });
      } else {
        // this.ebavCount = this.ebavCount + 1;
        if (arg2 !== 'saveExit' && this.$appSettings.dcoConfigurations.productsAllowedWithAccountDetails.includes(this.getProductType) && ((this.formInput.data[this.additionalInformationPage]?.bankAccount === 'true' && this.formInput.data[this.additionalInformationPage]?.ibanCurrency !== '' && this.formInput.data[this.additionalInformationPage]?.ibanCurrency !== 'EUR') || (this.formInput.data[this.additionalInformationPage]?.bankAccount === 'false' && this.formInput.data[this.additionalInformationPage]?.accountCurrency !== '' && this.formInput.data[this.additionalInformationPage]?.accountCurrency !== 'GBP'))) {
          this.displaySnackBar({ title: `${this.$t('messages.error')}`, content: this.$t('messages.save.currencyError'), type: 'error' });
        } else {
          const newProductInformation = JSON.stringify({
            productTypeCode: this.apiProductType.toLowerCase(),
            productId: productMapping.data.productCode,
            accountOwnership: productInformation?.accountOwnership,
            modeOfOperation: productInformation?.modeOfOperation,
            tenorFrequency: productMapping?.data?.isEndDateCommonForAllAccounts === null || productMapping?.data?.isEndDateCommonForAllAccounts === undefined || productMapping?.data?.isEndDateCommonForAllAccounts === false ? this.apiProductType === 'termdeposit' ? 'MONTH' : '' : '',
            tenorValue: productMapping?.data?.isEndDateCommonForAllAccounts === null || productMapping?.data?.isEndDateCommonForAllAccounts === undefined || productMapping?.data?.isEndDateCommonForAllAccounts === false ? this.apiProductType === 'termdeposit' ? 1 : '' : '',
            interestRate: '',
            postingRestriction: '',
            currencyCode: productMapping.data.currencyCode,
            maturityInstruction: '',
            module: productMapping?.data.module,
            purposeOfAccount: this.formInput.data[this.additionalInformationPage]?.purposeOfAccount || '',
            purposeOfAccountOthers: this.formInput.data[this.additionalInformationPage]?.purposeOfAccountOthers || '',
            expectedUsage: this.formInput.data[this.additionalInformationPage]?.expectedUsage || '',
            productEndDate: productMapping?.data?.productEndDate,
            isEndDateCommonForAllAccounts: productMapping?.data?.isEndDateCommonForAllAccounts,
            productSubType: this.getProductType || '',
          });
          const employmentDetails = {
            employmentStatus: this.formInput.data[this.additionalInformationPage]?.employmentStatus || '',
            nameOfTheEmployer: this.formInput.data[this.additionalInformationPage]?.nameOfTheEmployer || '',
            employmentType: this.formInput.data[this.additionalInformationPage]?.employmentType || '',
            businessType: this.formInput.data[this.additionalInformationPage]?.businessType || '',
            jobTitle: this.formInput.data[this.additionalInformationPage]?.jobTitle || '',
            paymentMethod: this.formInput.data[this.additionalInformationPage]?.paymentMethod || '',
            paymentFrequency: this.formInput.data[this.additionalInformationPage]?.paymentFrequency || '',
          };
          const updatePersonalInformation = JSON.stringify({
            titleCode: personalInformation?.titleCode,
            titleDescription: personalInformation?.titleDescription,
            gender: personalInformation?.gender,
            firstName: personalInformation?.firstName,
            middleName: personalInformation?.middleName,
            lastName: personalInformation?.lastName,
            dateOfBirth: personalInformation?.dateOfBirth,
            nationalIdTypeId: personalInformation?.nationalIdTypeId,
            nationalIdTypeCode: personalInformation?.nationalIdTypeCode,
            nationalIdNumber: personalInformation?.nationalIdNumber,
            residentCountryId: personalInformation?.residentCountryId,
            residentCountryCode: personalInformation?.residentCountryCode,
            birthCountryCode: personalInformation?.birthCountryCode,
            birthCountryName: personalInformation?.birthCountryName,
            areYouAUKResident: personalInformation?.areYouAUKResident,
            primaryNationality: personalInformation?.primaryNationality,
            primaryNationalityDescription: personalInformation?.primaryNationalityDescription,
            secondaryNationality: personalInformation?.secondaryNationality,
            preferredLanguageName: personalInformation?.preferredLanguageName,
            preferredLanguageCode: personalInformation?.preferredLanguageCode,
            expectedTurnover: /^\d+(\.\d{1,2})?$/.test(this.formInput.data[this.additionalInformationPage]?.expectedTurnover) ? this.formInput.data[this.additionalInformationPage]?.expectedTurnover : '',
            sourceCountryOfFunds: this.formInput.data[this.additionalInformationPage]?.sourceCountryOfFunds || '',
            job: this.formInput.data[this.additionalInformationPage]?.job || '',
            udfBusinessType: this.formInput.data[this.additionalInformationPage]?.udfBusinessType || '',
          });
          const data = {
            accountInformation: this.accountInformation,
            activeFlag: personalInfoResponse.activeFlag,
            activeFrom: personalInfoResponse.activeFrom,
            activeTill: personalInfoResponse.activeTill,
            applicationId: personalInfoResponse.applicationId,
            applicationNumber: personalInfoResponse.applicationNumber,
            applicationStatus: personalInfoResponse.applicationStatus,
            createdBy: personalInfoResponse.createdBy,
            createdDate: personalInfoResponse.createdDate,
            customerId: personalInfoResponse.customerId,
            deletedFlag: personalInfoResponse.deletedFlag,
            documentInformation: personalInfoResponse.documentInformation,
            emailId: personalInfoResponse.emailId,
            entityId: personalInfoResponse.entityId,
            lastModifiedBy: personalInfoResponse.lastModifiedBy,
            lastModifiedDate: personalInfoResponse.lastModifiedDate,
            mobileCountryCode: personalInfoResponse.mobileCountryCode,
            mobilePhoneNumber: personalInfoResponse.mobilePhoneNumber,
            otherInformation: {
              employmentDetails: employmentDetails,
              mobileNumberVerified: true,
              addressLookupEnabled: otherInformation && otherInformation?.addressLookupEnabled,
              lisaTransferInWithAgeValidation: this.getProductType === 'lifetimeISA' ? otherInformation && otherInformation?.lisaTransferInWithAgeValidation === undefined
                ? localStorage.getItem('isLisaTransferInWithAgeCheck') : otherInformation?.lisaTransferInWithAgeValidation : null,

            },
            personalInformation: updatePersonalInformation,
            productInformation: newProductInformation,
            contactInformation: personalInfoResponse.contactInformation,
            taxInformation: personalInfoResponse.taxInformation,
            readOnlyFlag: this.response.readOnlyFlag,
            statusInformation: null,
            systemFlag: personalInfoResponse.systemFlag,
            tenantId: personalInfoResponse.tenantId,
            version: personalInfoResponse.version,
            b2bSessionId: personalInfoResponse.b2bSessionId,
          };
          const url = urlObj.save;
          const ibanNumber = this.formInput?.data?.[this.additionalInformationPage]?.ibanNumber;
          const bicCode = this.formInput?.data?.[this.additionalInformationPage]?.bicCode;
          const ibanCurrency = this.formInput?.data?.[this.additionalInformationPage]?.ibanCurrency;
          const accountNumber = this.formInput?.data?.[this.additionalInformationPage]?.accountNumber;
          const sortCode = this.formInput?.data?.[this.additionalInformationPage]?.sortCodeResult;
          if (this.getProductType === 'termDeposit') {
            if (bankAccount === 'true') {
              const hasIbanDetails = ibanNumber !== '' && ibanNumber !== undefined && ibanNumber !== null && bicCode !== '' && bicCode !== undefined && bicCode !== null && ibanCurrency === 'EUR';
              this.dataObj.data.wizardSteps[pageBasedOnProducts[this.getProductType][this.applicantType]?.additionalInformation[0]].components.forEach((component) => {
                if (component && (component.key === 'ibanToggle' || component.key === 'currAndName')) {
                  component && component.components.forEach((subComponent) => {
                    subComponent && subComponent.forEach(async(childComponent) => {
                      if (childComponent && (childComponent.key === 'ibanNumber' || childComponent.key === 'bicCode' || childComponent.key === 'bankName' || childComponent.key === 'ibanCurrency')) {
                        if (hasIbanDetails) {
                          this.accountInformation = JSON.stringify({
                            isIBANAvailable: this.formInput.data[this.additionalInformationPage]?.bankAccount || '',
                            iban: this.formInput.data[this.additionalInformationPage]?.ibanNumber || '',
                            bicCode: this.formInput.data[this.additionalInformationPage]?.bicCode || '',
                            bankName: this.formInput.data[this.additionalInformationPage]?.bankName || '',
                            currency: this.formInput.data[this.additionalInformationPage]?.ibanCurrency || '',
                            sortCode: '',
                            accountNumber: '',
                            accountVerifiedFlag: true,
                            postingRestriction: '',
                          });
                        }
                      }
                    });
                  });
                }
              });
            } else if (bankAccount === 'false') {
              const accountNumberDetails = accountNumber !== '' && accountNumber !== undefined && accountNumber !== null && sortCode !== '' && sortCode !== undefined && sortCode !== null;
              this.dataObj.data.wizardSteps[pageBasedOnProducts[this.getProductType][this.applicantType]?.additionalInformation[0]].components.forEach((component) => {
                if (component && (component.key === 'accountNumberGrid' || component.key === 'sortCheck' || component.key === 'currAndName')) {
                  component && component.components.forEach((subComponent) => {
                    subComponent && subComponent.forEach(async(childComponent) => {
                      if (childComponent && (childComponent.key === 'accountNumber' || childComponent.key === 'sortCodeResult')) {
                        if (accountNumberDetails) {
                          this.accountInformation = JSON.stringify({
                            isIBANAvailable: this.formInput.data[this.additionalInformationPage]?.bankAccount || '',
                            iban: '',
                            bicCode: '',
                            bankName: this.formInput.data[this.additionalInformationPage]?.bankName || '',
                            currency: this.formInput.data[this.additionalInformationPage]?.accountCurrency || '',
                            sortCode: this.formInput.data[this.additionalInformationPage]?.sortCodeResult,
                            accountNumber: this.formInput.data[this.additionalInformationPage]?.accountNumber,
                            accountVerifiedFlag: true,
                            postingRestriction: '',
                          });
                        }
                      }
                    });
                  });
                }
              });
            }
          } else {
            if (bankAccount === 'true') {
              this.dataObj.data.wizardSteps[pageBasedOnProducts[this.getProductType][this.applicantType]?.additionalInformation[0]].components.forEach((component) => {
                if (component && (component.key === 'ibanToggle' || component.key === 'currAndName')) {
                  component && component.components.forEach((subComponent) => {
                    subComponent && subComponent.forEach(async(childComponent) => {
                      if (childComponent && (childComponent.key === 'ibanNumber' || childComponent.key === 'bicCode' || childComponent.key === 'bankName' || childComponent.key === 'ibanCurrency')) {
                        const ibanNum = childComponent?.key === 'ibanNumber' ? childComponent?.validate?.required : null;
                        const bicCode = childComponent?.key === 'bicCode' ? childComponent?.validate?.required : null;
                        const bankName = childComponent?.key === 'bankName' ? childComponent?.validate?.required : null;
                        const iCurrency = childComponent?.key === 'ibanCurrency' ? childComponent?.validate?.required : null;
                        if (ibanNum === 'true' && bicCode === 'true' && bankName === 'true' && iCurrency === 'true') {
                          this.accountInformation = JSON.stringify({
                            isIBANAvailable: this.formInput.data[this.additionalInformationPage]?.bankAccount || '',
                            iban: this.formInput.data[this.additionalInformationPage]?.ibanNumber || '',
                            bicCode: this.formInput.data[this.additionalInformationPage]?.bicCode || '',
                            bankName: this.formInput.data[this.additionalInformationPage]?.bankName || '',
                            currency: this.formInput.data[this.additionalInformationPage]?.ibanCurrency || '',
                            sortCode: '',
                            accountNumber: '',
                            accountVerifiedFlag: true,
                            postingRestriction: '',
                          });
                        } else {
                          this.accountInformation = !this.isValueValid(this.formInput.data[this.additionalInformationPage]?.bicCode) && !this.isValueValid(this.formInput.data[this.additionalInformationPage]?.ibanNumber) ? null : JSON.stringify({
                            isIBANAvailable: this.formInput.data[this.additionalInformationPage]?.bankAccount || '',
                            iban: this.formInput.data[this.additionalInformationPage]?.ibanNumber || '',
                            bicCode: this.formInput.data[this.additionalInformationPage]?.bicCode || '',
                            bankName: this.formInput.data[this.additionalInformationPage]?.bankName || '',
                            currency: this.formInput.data[this.additionalInformationPage]?.ibanCurrency || '',
                            sortCode: '',
                            accountNumber: '',
                            accountVerifiedFlag: true,
                            postingRestriction: '',
                          });
                        }
                      }
                    });
                  });
                }
              });
            } else if (bankAccount === 'false') {
              this.dataObj.data.wizardSteps[pageBasedOnProducts[this.getProductType][this.applicantType]?.additionalInformation[0]].components.forEach((component) => {
                if (component && (component.key === 'accountNumberGrid' || component.key === 'sortCheck' || component.key === 'currAndName')) {
                  component && component.components.forEach((subComponent) => {
                    subComponent && subComponent.forEach(async(childComponent) => {
                      if (childComponent && (childComponent.key === 'accountNumber' || childComponent.key === 'sortCodeResult' || childComponent.key === 'bankName')) {
                        const accNum = childComponent?.key === 'accountNumber' ? childComponent?.validate?.required : null;
                        const sortCode = childComponent?.key === 'sortCodeResult' ? childComponent?.validate?.required : null;
                        const bankName = childComponent?.key === 'bankName' ? childComponent?.validate?.required : null;
                        if (accNum === 'true' && sortCode === 'true' && bankName === 'true') {
                          this.accountInformation = JSON.stringify({
                            isIBANAvailable: this.formInput.data[this.additionalInformationPage]?.bankAccount || '',
                            iban: '',
                            bicCode: '',
                            bankName: this.formInput.data[this.additionalInformationPage]?.bankName || '',
                            currency: this.formInput.data[this.additionalInformationPage]?.accountCurrency || '',
                            sortCode: this.formInput.data[this.additionalInformationPage]?.sortCodeResult,
                            accountNumber: this.formInput.data[this.additionalInformationPage]?.accountNumber,
                            accountVerifiedFlag: true,
                            postingRestriction: '',
                          });
                        } else {
                          this.accountInformation = !this.isValueValid(this.formInput.data[this.additionalInformationPage]?.accountNumber) && !this.isValueValid(this.formInput.data[this.additionalInformationPage]?.sortCodeResult) ? null : JSON.stringify({
                            isIBANAvailable: this.formInput.data[this.additionalInformationPage]?.bankAccount || '',
                            iban: '',
                            bicCode: '',
                            bankName: this.formInput.data[this.additionalInformationPage]?.bankName || '',
                            currency: this.formInput.data[this.additionalInformationPage]?.accountCurrency || '',
                            sortCode: this.formInput.data[this.additionalInformationPage]?.sortCodeResult,
                            accountNumber: this.formInput.data[this.additionalInformationPage]?.accountNumber,
                            accountVerifiedFlag: true,
                            postingRestriction: '',
                          });
                        }
                      }
                    });
                  });
                }
              });
            }
          }
          data.accountInformation = this.accountInformation;
          const additionalInfoData = arg2 === 'saveExit' ? await CommonService.postData(`${url}/${'saveAndExit=true'}`, data) : await CommonService.postData(urlObj.save, data);

          this.reviewInformation = additionalInfoData;
          store.dispatch('userStore/setUserData', {
            additionalInfoData,
          });
          localStorage.setItem('additionalInfoData', JSON.stringify(additionalInfoData));
          if (additionalInfoData !== '' && additionalInfoData !== null && arg2 === undefined && additionalInfoData?.status !== 400) {
            if (pageBasedOnProducts[this.getProductType][this.applicantType]?.accountInformation !== undefined && productInformation?.accountOwnership === 'JOINT') {
              const primaryProfileImage = await CommonService.getDocumentUpload(`${urlObj.getUpload}/${personalInfoResponse.entityId}/${'FECO_PROOF_CATEGORY_PHOTO'}/${'Primary'}`, { b2bSessionId: personalInfoResponse.b2bSessionId });

              if (primaryProfileImage?.data?.length > 0) {
                this.IDVForSecondaryApplicant = false;
              } else {
                this.IDVForSecondaryApplicant = true;
              }
              localStorage.setItem('IDVEnabled', this.IDVForSecondaryApplicant);
              this.modalConfig.content = '';
              this.modelDataObj = response;
              this.modalConfig.close = true;
              this.modalFormCode = response?.data?.entityCode;
              this.modalConfig.title = 'secondaryApplicant';
              this.modalConfig.width = 510;
              this.modalConfig.rounded = true;
              this.modalConfig.hideToolbar = true;
              this.modalConfig.enableSaveButton = false;
              this.modalConfig.saveButton = this.$t(`formStaticValue.${this.modalFormCode}.save`);
              this.modalConfig.cancelButton = this.$t(`formStaticValue.${this.modalFormCode}.cancel`);
              this.modalConfig.cancelCallback = () => {
                this.modelDataObj = {};
              };
              this.modalConfig.saveCallback = () => {
                this.modelDataObj = {};
              };
              this.modalConfig.enabled = true;
            } else {
              this.$router.push({ params: { action: 'ReviewInformation' } });
            }
          } else if (additionalInfoData !== '' && additionalInfoData !== null && arg2 === 'saveExit' && additionalInfoData?.status !== 400) {
            this.displaySnackBar({ title: `${this.$t('messages.save.success')}`, content: this.$t('messages.save.saveSuccess'), type: 'success' });
            const redirectTimeout = this.$appSettings?.dco?.redirectTimeout;

            setTimeout(function() {
              window.location.href = appSettings.dco.bankProductPage;
            }, redirectTimeout);
          } else if (additionalInfoData?.status === 400) {
            this.displaySnackBar({ title: `${this.$t('messages.error')}`, content: additionalInfoData.data.causes[0].message, type: 'error' });
          }
        }
      }
    },
    async deleteData(arg1) {
      const entityId =
        arg1 === 1 ? this.response.entityId : store.getters['userStore/userData']?.personalInformationData?.entityId;
      const deleteDatas = await CommonService.deleteDcoData(`${urlObj.deleteData}/${entityId}`);

      if (deleteDatas.status === 204 || deleteDatas.status === 200) {
        this.displaySnackBar({ title: `${this.$t('messages.save.success')}`, content: this.$t('messages.save.deleteSuccess'), type: 'success' });
        const redirectTimeout = this.$appSettings?.dco?.redirectTimeout;
        setTimeout(function() {
          window.location.href = appSettings.dco.bankProductPage;
        }, redirectTimeout);
      }
    },
    async quitApplication() {
      const mobileNumbers = localStorage.getItem('mobileNumber') ? JSON.parse(localStorage.getItem('mobileNumber')) : store.getters['userStore/userData']?.mobileNumber;
      const mobilePhoneNumber = mobileNumbers.mobilePhoneNumber;
      const mobileCountryCode = mobileNumbers.mobileCountryCode.replaceAll(
        '+',
        '%2B',
      );
      const additionalInfoData = await CommonService.quitApplication(`${urlObj.quitApplication}/${mobileCountryCode}/${mobilePhoneNumber}`);

      if (additionalInfoData) {
        const id = additionalInfoData.data.entityId;
        const deleteDatas = await CommonService.deleteDcoData(`${urlObj.deleteData}/${id}`);
        if (deleteDatas.status === 204 || deleteDatas.status === 200) {
          this.displaySnackBar({ title: `${this.$t('messages.save.success')}`, content: this.$t('messages.save.deleteSuccess'), type: 'success' });
          const redirectTimeout = this.$appSettings?.dco?.redirectTimeout;
          setTimeout(function() {
            window.location.href = appSettings.dco.bankProductPage;
          }, redirectTimeout);
        }
      }
    },
    async updateSecondaryApplicantData(arg2) {
      this.additionalInformationPage = pageBasedOnProducts[this.getProductType][this.applicantType]?.additionalInformation[1];

      if (arg2 !== 'saveExit' && this.formInput.data[this.additionalInformationPage]?.expectedTurnover !== undefined && this.formInput.data[this.additionalInformationPage]?.expectedTurnover !== '' && !(/^\d+(\.\d{1,2})?$/.test(this.formInput.data[this.additionalInformationPage]?.expectedTurnover))) {
        this.displaySnackBar({ title: `${this.$t('messages.error')}`, content: this.$t('messages.save.invalidFormatError'), type: 'error' });
      } else {
        const productMapping = store?.getters['userStore/userData']?.productInfo;
        const response = store.getters['userStore/userData']?.personalInformationData;
        const personalInfoResponse = response && response.data ? response.data : response;
        const personalInformation = JSON.parse(personalInfoResponse.personalInformation);
        const otherInformation = JSON.parse(personalInfoResponse?.otherInformation);
        const productInformation = JSON.parse(personalInfoResponse.productInformation);
        const newProductInformation = productInformation.productId === productMapping.data.productCode
          ? JSON.stringify({
            productTypeCode: this.apiProductType.toLowerCase(),
            productId: productMapping.data.productCode,
            accountOwnership: productInformation?.accountOwnership,
            modeOfOperation: productInformation?.modeOfOperation,
            tenorFrequency: productMapping?.data?.isEndDateCommonForAllAccounts === null || productMapping?.data?.isEndDateCommonForAllAccounts === undefined || productMapping?.data?.isEndDateCommonForAllAccounts === false ? this.apiProductType === 'termdeposit' ? 'MONTH' : '' : '',
            tenorValue: productMapping?.data?.isEndDateCommonForAllAccounts === null || productMapping?.data?.isEndDateCommonForAllAccounts === undefined || productMapping?.data?.isEndDateCommonForAllAccounts === false ? this.apiProductType === 'termdeposit' ? 1 : '' : '',
            interestRate: productInformation?.interestRate,
            postingRestriction: productInformation?.postingRestriction,
            currencyCode: productMapping.data.currencyCode,
            maturityInstruction: productInformation?.maturityInstruction,
            module: productInformation?.module,
            purposeOfAccount: productInformation?.purposeOfAccount,
            purposeOfAccountOthers: productInformation?.purposeOfAccountOthers,
            expectedUsage: productInformation?.expectedUsage,
            purposeOfAccountDescription: productInformation?.purposeOfAccountDescription || '',
            expectedUsageDescription: productInformation?.expectedUsageDescription || '',
            productEndDate: productMapping?.data?.productEndDate,
            isEndDateCommonForAllAccounts: productMapping?.data?.isEndDateCommonForAllAccounts,
            productSubType: this.getProductType || '',
          }) : JSON.stringify({
            productTypeCode: this.apiProductType.toLowerCase(),
            productId: productMapping.data.productCode,
            accountOwnership: '',
            modeOfOperation: '',
            tenorFrequency: productMapping?.data?.isEndDateCommonForAllAccounts === null || productMapping?.data?.isEndDateCommonForAllAccounts === undefined || productMapping?.data?.isEndDateCommonForAllAccounts === false ? this.apiProductType === 'termdeposit' ? 'MONTH' : '' : '',
            tenorValue: productMapping?.data?.isEndDateCommonForAllAccounts === null || productMapping?.data?.isEndDateCommonForAllAccounts === undefined || productMapping?.data?.isEndDateCommonForAllAccounts === false ? this.apiProductType === 'termdeposit' ? 1 : '' : '',
            interestRate: '',
            postingRestriction: '',
            currencyCode: productMapping.data.currencyCode,
            maturityInstruction: '',
            module: productMapping.data?.module,
            purposeOfAccount: productInformation?.purposeOfAccount,
            purposeOfAccountOthers: productInformation?.purposeOfAccountOthers,
            expectedUsage: productInformation?.expectedUsage,
            purposeOfAccountDescription: productInformation?.purposeOfAccountDescription || '',
            expectedUsageDescription: productInformation?.expectedUsageDescription || '',
            productEndDate: productMapping?.data?.productEndDate,
            isEndDateCommonForAllAccounts: productMapping?.data?.isEndDateCommonForAllAccounts,
            productSubType: this.getProductType || '',
          });
        const employmentDetails = {
          employmentStatus: this.formInput.data[this.additionalInformationPage]?.employmentStatus || '',
          nameOfTheEmployer: this.formInput.data[this.additionalInformationPage]?.nameOfTheEmployer || '',
          employmentType: this.formInput.data[this.additionalInformationPage]?.employmentType || '',
          businessType: this.formInput.data[this.additionalInformationPage]?.businessType || '',
          jobTitle: this.formInput.data[this.additionalInformationPage]?.jobTitle || '',
          paymentMethod: this.formInput.data[this.additionalInformationPage]?.paymentMethod || '',
          paymentFrequency: this.formInput.data[this.additionalInformationPage]?.paymentFrequency || '',
        };
        const data = {
          accountInformation: personalInfoResponse?.accountInformation,
          activeFlag: personalInfoResponse.activeFlag,
          activeFrom: personalInfoResponse.activeFrom,
          activeTill: personalInfoResponse.activeTill,
          applicationId: personalInfoResponse.applicationId,
          applicationNumber: personalInfoResponse.applicationNumber,
          applicationStatus: personalInfoResponse.applicationStatus,
          createdBy: personalInfoResponse.createdBy,
          createdDate: personalInfoResponse.createdDate,
          customerId: personalInfoResponse.customerId,
          deletedFlag: personalInfoResponse.deletedFlag,
          documentInformation: personalInfoResponse.documentInformation,
          emailId: personalInfoResponse.emailId,
          entityId: personalInfoResponse.entityId,
          lastModifiedBy: personalInfoResponse.lastModifiedBy,
          lastModifiedDate: personalInfoResponse.lastModifiedDate,
          mobileCountryCode: personalInfoResponse.mobileCountryCode,
          mobilePhoneNumber: personalInfoResponse.mobilePhoneNumber,
          otherInformation: {
            employmentDetails: otherInformation?.employmentDetails,
            mobileNumberVerified: true,
            addressLookupEnabled: otherInformation && otherInformation?.addressLookupEnabled,
            lisaTransferInWithAgeValidation: this.getProductType === 'lifetimeISA' ? otherInformation && otherInformation?.lisaTransferInWithAgeValidation === undefined
              ? localStorage.getItem('isLisaTransferInWithAgeCheck') : otherInformation?.lisaTransferInWithAgeValidation : null,
            secondaryApplicantsOtherInformation: [{
              relationshipType: this.formInput.data.page3.relationshipType,
              employmentDetails: employmentDetails,
            }],
          },
          personalInformation: JSON.stringify({
            titleCode: personalInformation?.titleCode,
            titleDescription: personalInformation?.titleDescription,
            gender: personalInformation?.gender,
            firstName: personalInformation?.firstName,
            middleName: personalInformation?.middleName,
            lastName: personalInformation?.lastName,
            dateOfBirth: personalInformation?.dateOfBirth,
            nationalIdTypeId: personalInformation?.nationalIdTypeId,
            nationalIdTypeCode: personalInformation?.nationalIdTypeCode,
            nationalIdNumber: personalInformation?.nationalIdNumber,
            residentCountryId: 'UK',
            residentCountryCode: 'UK',
            birthCountryCode: personalInformation?.birthCountryCode,
            birthCountryName: personalInformation?.birthCountryName,
            areYouAUKResident: personalInformation?.areYouAUKResident,
            primaryNationality: personalInformation?.primaryNationality,
            primaryNationalityDescription: personalInformation?.primaryNationalityDescription,
            secondaryNationality: personalInformation?.secondaryNationality,
            preferredLanguageName: '',
            preferredLanguageCode: personalInformation?.preferredLanguageCode,
            expectedTurnover: personalInformation?.expectedTurnover,
            sourceCountryOfFunds: personalInformation?.sourceCountryOfFunds,
            sourceCountryOfFundsDescription: personalInformation?.sourceCountryOfFundsDescription,
            job: personalInformation?.job,
            jobDescription: personalInformation?.jobDescription,
            udfBusinessType: personalInformation?.udfBusinessType,
            udfBusinessTypeDescription: personalInformation?.udfBusinessTypeDescription,
            secondaryApplicantsPersonalInformation: [
              {
                titleCode: personalInformation?.secondaryApplicantsPersonalInformation?.[0]?.titleCode,
                titleDescription: personalInformation?.secondaryApplicantsPersonalInformation?.[0]?.titleDescription,
                gender: personalInformation?.secondaryApplicantsPersonalInformation?.[0]?.gender,
                firstName: personalInformation?.secondaryApplicantsPersonalInformation?.[0]?.firstName,
                middleName: personalInformation?.secondaryApplicantsPersonalInformation?.[0]?.middleName,
                lastName: personalInformation?.secondaryApplicantsPersonalInformation?.[0]?.lastName,
                dateOfBirth: personalInformation?.secondaryApplicantsPersonalInformation?.[0]?.dateOfBirth,
                nationalIdTypeId: personalInformation?.secondaryApplicantsPersonalInformation?.[0]?.nationalIdTypeId,
                nationalIdTypeCode: personalInformation?.secondaryApplicantsPersonalInformation?.[0]?.nationalIdTypeCode,
                nationalIdNumber: personalInformation?.secondaryApplicantsPersonalInformation?.[0]?.nationalIdNumber,
                residentCountryId: 'UK',
                residentCountryCode: 'UK',
                birthCountryCode: personalInformation?.secondaryApplicantsPersonalInformation?.[0]?.birthCountryCode,
                birthCountryName: personalInformation?.secondaryApplicantsPersonalInformation?.[0]?.birthCountryName,
                areYouAUKResident: personalInformation?.secondaryApplicantsPersonalInformation?.[0]?.areYouAUKResident,
                primaryNationality: personalInformation?.secondaryApplicantsPersonalInformation?.[0]?.primaryNationality,
                primaryNationalityDescription: personalInformation?.secondaryApplicantsPersonalInformation?.[0]?.primaryNationalityDescription,
                secondaryNationality: personalInformation?.secondaryApplicantsPersonalInformation?.[0]?.secondaryNationality,
                preferredLanguageName: '',
                preferredLanguageCode: personalInformation?.secondaryApplicantsPersonalInformation?.[0]?.preferredLanguageCode,
                secondaryApplicantsEmailId: personalInformation?.secondaryApplicantsPersonalInformation?.[0]?.secondaryApplicantsEmailId,
                secondaryApplicantsMobileCountryCode: personalInformation?.secondaryApplicantsPersonalInformation?.[0]?.secondaryApplicantsMobileCountryCode,
                secondaryApplicantsMobilePhoneNumber: personalInformation?.secondaryApplicantsPersonalInformation?.[0]?.secondaryApplicantsMobilePhoneNumber,
                expectedTurnover: (/^\d+(\.\d{1,2})?$/.test(this.formInput?.data?.page3?.expectedTurnover)) ? this.formInput.data.page3?.expectedTurnover : '',
                sourceCountryOfFunds: this.formInput.data.page3?.sourceCountryOfFunds || '',
                job: this.formInput.data.page3?.job || '',
                udfBusinessType: this.formInput.data.page3?.udfBusinessType || '',
              }],
          }),
          productInformation: newProductInformation,
          contactInformation: personalInfoResponse.contactInformation,
          taxInformation: personalInfoResponse.taxInformation,
          readOnlyFlag: this.response.readOnlyFlag,
          statusInformation: null,
          systemFlag: personalInfoResponse.systemFlag,
          tenantId: personalInfoResponse.tenantId,
          version: personalInfoResponse.version,
          b2bSessionId: personalInfoResponse.b2bSessionId,
        };
        const url = urlObj.save;

        const additionalInfoData = arg2 === 'saveExit' ? await CommonService.postData(`${url}/${'saveAndExit=true'}`, data) : await CommonService.postData(urlObj.save, data);
        this.reviewInformation = additionalInfoData;
        store.dispatch('userStore/setUserData', {
          additionalInfoData,
        });
        if (additionalInfoData !== '' && additionalInfoData !== null && arg2 === undefined && additionalInfoData?.status !== 400) {
          this.$router.push({ params: { action: 'ReviewInformation' } });
        } else if (additionalInfoData !== '' && additionalInfoData !== null && arg2 === 'saveExit' && additionalInfoData?.status !== 400) {
          this.displaySnackBar({ title: `${this.$t('messages.save.success')}`, content: this.$t('messages.save.saveSuccess'), type: 'success' });
          const redirectTimeout = this.$appSettings?.dco?.redirectTimeout;

          setTimeout(function() {
            window.location.href = appSettings.dco.bankProductPage;
          }, redirectTimeout);
        } else if (additionalInfoData?.status === 400) {
          this.displaySnackBar({ title: `${this.$t('messages.error')}`, content: additionalInfoData.data.causes[0].message, type: 'error' });
        }
      }
    },
    async deleteSecondaryApplicantData(responseData) {
      const response = responseData;
      const personalInfoResponse = response && response.data ? response.data : response;
      const secondaryData = JSON.parse(personalInfoResponse);
      const personalInformation = JSON.parse(secondaryData?.personalInformation);
      const taxInformation = JSON.parse(secondaryData?.taxInformation);
      const otherInformation = JSON.parse(secondaryData?.otherInformation);
      const contactInformation = JSON.parse(secondaryData?.contactInformation);
      let productInformation = JSON.parse(secondaryData?.productInformation);
      const productMapping = store?.getters['userStore/userData']?.productInfo;
      const hadSecondaryApplicantsData = !!(personalInformation?.secondaryApplicantsPersonalInformation && personalInformation.secondaryApplicantsPersonalInformation.length > 0);

      productInformation = JSON.stringify({
        productTypeCode: this.apiProductType.toLowerCase(),
        productId: this.getProductCode,
        accountOwnership: 'SOLE',
        modeOfOperation: 'SOLE',
        tenorFrequency: productMapping?.data?.isEndDateCommonForAllAccounts === null || productMapping?.data?.isEndDateCommonForAllAccounts === undefined || productMapping?.data?.isEndDateCommonForAllAccounts === false ? this.apiProductType === 'termdeposit' ? 'MONTH' : '' : '',
        tenorValue: productMapping?.data?.isEndDateCommonForAllAccounts === null || productMapping?.data?.isEndDateCommonForAllAccounts === undefined || productMapping?.data?.isEndDateCommonForAllAccounts === false ? this.apiProductType === 'termdeposit' ? 1 : '' : '',
        interestRate: '',
        postingRestriction: '',
        currencyCode: productInformation?.currencyCode,
        maturityInstruction: '',
        module: productMapping?.data.module,
        purposeOfAccount: productInformation?.purposeOfAccount || '',
        purposeOfAccountOthers: productInformation?.purposeOfAccountOthers || '',
        expectedUsage: productInformation?.expectedUsage || '',
        purposeOfAccountDescription: productInformation?.purposeOfAccountDescription || '',
        expectedUsageDescription: productInformation?.expectedUsageDescription || '',
        productEndDate: productMapping?.data?.productEndDate,
        isEndDateCommonForAllAccounts: productMapping?.data?.isEndDateCommonForAllAccounts,
        productSubType: this.getProductType || '',
      });

      delete personalInformation?.secondaryApplicantsPersonalInformation;
      delete taxInformation?.secondaryApplicantsTaxInformation;
      delete otherInformation?.secondaryApplicantsOtherInformation;
      delete contactInformation?.secondaryApplicantsContactInformation;

      secondaryData.productInformation = productInformation;
      secondaryData.personalInformation = JSON.stringify(personalInformation);
      secondaryData.taxInformation = JSON.stringify(taxInformation);
      secondaryData.otherInformation = otherInformation;
      secondaryData.contactInformation = JSON.stringify(contactInformation);
      secondaryData.statusInformation = null; // as no data is captured related to status until it reaches review screen the value null is assigned.

      const additionalInfoData = await CommonService.postData(urlObj.save, secondaryData);

      this.reviewInformation = additionalInfoData;
      store.dispatch('userStore/setUserData', {
        additionalInfoData,
      });
      if (additionalInfoData) {
        if (hadSecondaryApplicantsData) {
          this.displaySnackBar({ title: `${this.$t('messages.save.success')}`, content: this.$t('messages.save.deleteSuccess'), type: 'success' });
        }
        this.saveResponse.data = additionalInfoData;
        this.modalConfig.enabled = false;
        await this.languageDifferent();
      }
    },
    async updateAccountOwnership(data) {
      const response = JSON.parse(data);
      let productInformation = JSON.parse(response?.productInformation);
      const productMapping = store?.getters['userStore/userData']?.productInfo;
      const personalInformation = JSON.parse(response?.personalInformation);
      const hadSecondaryApplicantsData = !!(personalInformation?.secondaryApplicantsPersonalInformation && personalInformation.secondaryApplicantsPersonalInformation.length > 0);

      productInformation = JSON.stringify({
        productTypeCode: this.apiProductType.toLowerCase(),
        productId: this.getProductCode,
        accountOwnership: 'SOLE',
        modeOfOperation: 'SOLE',
        tenorFrequency: productMapping?.data?.isEndDateCommonForAllAccounts === null || productMapping?.data?.isEndDateCommonForAllAccounts === undefined || productMapping?.data?.isEndDateCommonForAllAccounts === false ? this.apiProductType === 'termdeposit' ? 'MONTH' : '' : '',
        tenorValue: productMapping?.data?.isEndDateCommonForAllAccounts === null || productMapping?.data?.isEndDateCommonForAllAccounts === undefined || productMapping?.data?.isEndDateCommonForAllAccounts === false ? this.apiProductType === 'termdeposit' ? 1 : '' : '',
        interestRate: '',
        postingRestriction: '',
        currencyCode: productInformation?.currencyCode,
        maturityInstruction: '',
        module: productMapping?.data.module,
        purposeOfAccount: productInformation?.purposeOfAccount || '',
        purposeOfAccountOthers: productInformation?.purposeOfAccountOthers || '',
        expectedUsage: productInformation?.expectedUsage || '',
        purposeOfAccountDescription: productInformation?.purposeOfAccountDescription || '',
        expectedUsageDescription: productInformation?.expectedUsageDescription || '',
        productEndDate: productMapping?.data?.productEndDate,
        isEndDateCommonForAllAccounts: productMapping?.data?.isEndDateCommonForAllAccounts,
        productSubType: this.getProductType || '',
      });
      response.productInformation = productInformation;
      response.otherInformation = JSON.parse(response?.otherInformation);

      const additionalInfoData = await CommonService.postData(`${urlObj.save}/${'saveAndExit=true'}`, response);

      this.reviewInformation = additionalInfoData;
      store.dispatch('userStore/setUserData', {
        additionalInfoData,
      });
      const personalInformationData = additionalInfoData;

      store.dispatch('userStore/setUserData', {
        personalInformationData,
      });
      if (additionalInfoData) {
        this.saveResponse.data = additionalInfoData;
        if (hadSecondaryApplicantsData) {
          this.displaySnackBar({ title: `${this.$t('messages.save.success')}`, content: this.$t('messages.save.deleteSuccess'), type: 'success' });
        }
        const navMapFilename = this.navigationMapping[this.getProductType].productOnboard;
        const dataObj = await this.fetchSchema({
          mode: process.env.NODE_ENV,
          tenantID: await CommonService.getTenantId() || process.env.DEFAULT_TENANTID,
          navMapFilename,
        });
        const route = this.getRouteInformation('primary', dataObj, additionalInfoData);
        if (route?.query !== undefined) {
          this.$router.push({ params: { action: route?.action }, query: route?.query });
        } else {
          this.$router.push({ params: { action: route?.action } });
        }
        // this.$router.push({ params: { action: 'productOnboard' }, query: { type: 'PersonalInformation' } });
      }
    },
    async partialDataSaved() {
      let addressSameAsPrimary = false;
      let addressLookupEnabled = false;

      const productMapping = store?.getters['userStore/userData']?.productInfo;
      const localeSelected = localStorage.getItem('localeSelected');

      this.resumeTaxInformation = JSON.parse(this.savePersonalResponse?.data?.taxInformation);
      this.otherInformation = JSON.parse(this.savePersonalResponse?.data?.otherInformation);
      this.resumePersonalInformation = JSON.parse(this.savePersonalResponse.data.personalInformation);
      addressLookupEnabled = this.otherInformation?.addressLookupEnabled === true ? 'true' : 'false';

      this.formInput.data[this.personalInformationPage].entityId1 = this.savePersonalResponse.data.entityId;
      this.formInput.data[this.additionalInformationPage].entityId1 = this.savePersonalResponse.data.entityId;

      if (this.applicantType === 'secondary') {
        this.resumeTaxInformation = this.resumeTaxInformation?.secondaryApplicantsTaxInformation && this.resumeTaxInformation?.secondaryApplicantsTaxInformation[0] ? this.resumeTaxInformation?.secondaryApplicantsTaxInformation[0] : '';
        this.otherInformation = this.resumeTaxInformation?.secondaryApplicantsOtherInformation !== undefined && this.resumeTaxInformation?.secondaryApplicantsOtherInformation[0] !== undefined ? this.resumeTaxInformation?.secondaryApplicantsOtherInformation[0] : '';
        this.resumePersonalInformation = this.resumePersonalInformation?.secondaryApplicantsPersonalInformation[0];
        this.formInput.data.page2.partiallySavedData = JSON.stringify(this.savePersonalResponse?.data);
        this.formInput.data.page1.mobileCountryCode = this.savePersonalResponse?.data?.mobileCountryCode;
        this.formInput.data.page1.mobilePhoneNumber = this.savePersonalResponse?.data?.mobilePhoneNumber;
        this.formInput.data.page1.applicationId = this.savePersonalResponse?.data?.applicationId;
      }
      for (const data in this.formInput.data[this.personalInformationPage]) {
        for (const information in this.resumePersonalInformation) {
          if (data === information) {
            this.formInput.data[this.personalInformationPage][data] = this.resumePersonalInformation[information];
          }
        }
      }
      this.formInput.data[this.personalInformationPage] = Object.assign(
        {},
        {
          ...this.formInput.data[this.personalInformationPage],
          ...{
            preferredLanguageCode: localeSelected,
            resumeResponse: this.savePersonalResponse?.data ? JSON.stringify(this.savePersonalResponse.data) : JSON.stringify(this.savePersonalResponse),
            productType: this.getProductType.toLowerCase(),
            productCode: productMapping.data.productCode,
            currencyCode: productMapping.data.currencyCode,
            isFromResumeProcess: 'true',
            entityId: this.savePersonalResponse.data.entityId,
            gender: this.resumePersonalInformation?.gender,
            firstName: this.resumePersonalInformation?.firstName,
            nationalIdTypeId: this.resumePersonalInformation?.nationalIdTypeId,
            nationalIdNumber: this.resumePersonalInformation?.nationalIdNumber,
            otherInformation: this.savePersonalResponse?.data?.otherInformation,
            birthCountryCode: this.resumePersonalInformation?.birthCountryCode,
            tax: this.resumeTaxInformation === null ? 'true' : this.resumeTaxInformation?.taxPayerFlag === 'true' || this.resumeTaxInformation === '' ? 'true' : 'false',
            countryOfTaxResidentCode: this.resumeTaxInformation === null || this.resumeTaxInformation === '' ? 'GBR' : this.resumeTaxInformation?.countryOfTaxResidentCode,
            taxIdentificationNumber: this.resumeTaxInformation?.taxIdentificationNumber,
            taxResidentInOtherCountry: this.resumeTaxInformation?.taxResidentInOtherCountry === 'true' ? 'true' : 'false',
            foreignCountryOfTaxResidence: this.resumeTaxInformation?.foreignCountryOfTaxResidence,
            tinNumberInOtherCountry: this.resumeTaxInformation?.tinNumberInOtherCountry,
            areYouUSResident: this.resumeTaxInformation?.areYouUSResident && this.resumeTaxInformation?.areYouUSResident !== '' ? this.resumeTaxInformation.areYouUSResident === 'true' ? 'true' : 'false' : 'true',
            statusInformation: this.savePersonalResponse?.data?.statusInformation,
            titleCode: this.resumePersonalInformation?.titleCode,
            middleName: this.resumePersonalInformation?.middleName,
            singleChoice2: this.formInput.data[this.personalInformationPage]?.middleName && this.formInput.data[this.personalInformationPage]?.middleName !== '' ? 'true' : 'false',
            lastName: this.resumePersonalInformation?.lastName,
            ukResident: this.resumePersonalInformation?.areYouAUKResident && this.resumePersonalInformation?.areYouAUKResident === 'true' ? 'true' : 'false',
            primaryNationality: this.resumePersonalInformation?.primaryNationality,
            taxExemptionReason: this.resumeTaxInformation?.taxExemptionReason,
            mobileCountryCode: this.savePersonalResponse?.data?.mobileCountryCode,
            mobilePhoneNumber: this.savePersonalResponse?.data?.mobilePhoneNumber,
            applicationId: this.savePersonalResponse?.data?.applicationId,
            b2bSessionId: this.savePersonalResponse?.data?.b2bSessionId,
          },
        },
      );
      const data = this.resumePersonalInformation?.dateOfBirth?.split('-');

      if ((this.getProductType === 'lifetimeISA' && this.lisaEligibilityPassed && data.length !== 0) || (this.getProductType !== 'lifetimeISA' && data?.length > 0)) {
        this.formInput.data[this.personalInformationPage].year = data[0];
        this.formInput.data[this.personalInformationPage].month = data[1];
        this.formInput.data[this.personalInformationPage].date = data[2];
      }
      if (this.savePersonalResponse.data.contactInformation === null) {
        this.formInput.data[this.personalInformationPage].isAddressLookUpEnabled = this.otherInformation?.addressLookupEnabled === true ? 'true' : 'false';
      }
      const status = await CommonService.addressLookup(urlObj.addressLookup, {
        postCode: 'ln119hf',
        b2bSessionId: this.formInput.data.page2.b2bSessionId,
      }, false);

      store.dispatch('appStore/setAppData', {
        inProgress: false,
      });

      if (this.savePersonalResponse.data.contactInformation !== null) {
        if (this.applicantType === 'secondary') {
          this.resumeContactInformation = this.resumeContactInformation?.secondaryApplicantsContactInformation ? this.resumeContactInformation?.secondaryApplicantsContactInformation[0] : '';
        } else {
          this.resumeContactInformation = JSON.parse(this.savePersonalResponse.data?.contactInformation);
        }
        if (this.resumeContactInformation?.primaryAddress?.addressLine1 && this.resumeContactInformation?.primaryAddress?.addressLine1 !== '' && this.resumeContactInformation.primaryAddress?.addressID && this.resumeContactInformation?.primaryAddress?.addressID !== '' && status && status?.data?.isAddressLookupEnabled) {
          this.formInput.data[this.personalInformationPage] = Object.assign(
            {},
            {
              ...this.formInput.data[this.personalInformationPage],
              ...{
                isAddressLookUpEnabled: 'true',
                primaryPostCode: this.resumeContactInformation.primaryAddress.postCode,
                primaryAddressId: this.resumeContactInformation.primaryAddress.addressID,
                residentialAddress: this.resumeContactInformation.primaryAddress.addressText,
                primaryAddressLine1: this.resumeContactInformation.primaryAddress.addressLine1,
                primaryAddressLine2: this.resumeContactInformation.primaryAddress.addressLine2,
                primaryAddressLine3: this.resumeContactInformation.primaryAddress.addressLine3,
                primaryAddressLine4: this.resumeContactInformation.primaryAddress.addressLine4,
                addressLine5: this.resumeContactInformation.primaryAddress.addressLine5,
                addressLine6: this.resumeContactInformation.primaryAddress.addressLine6,
                primaryCountryCode: this.resumeContactInformation.primaryAddress.countryCode,
                primaryCity: this.resumeContactInformation.primaryAddress.city,
                primaryStateOrprovince: this.resumeContactInformation?.primaryAddress?.stateOrprovince,
              },
            },
          );
        } else {
          this.formInput.data[this.personalInformationPage] = Object.assign(
            {},
            {
              ...this.formInput.data[this.personalInformationPage],
              ...{
                isAddressLookUpEnabled: status && status?.data?.isAddressLookupEnabled ? 'true' : 'false',
                manualAddressToggle: status && status?.data?.isAddressLookupEnabled && this.resumeContactInformation.primaryAddress?.addressID !== undefined && this.resumeContactInformation.primaryAddress?.addressID !== null && this.resumeContactInformation.primaryAddress?.addressID !== '' ? 'false' : 'true',
                postCodeText: this.resumeContactInformation?.primaryAddress?.postCode,
                AddressLine1: this.resumeContactInformation?.primaryAddress?.addressLine1,
                AddressLine2: this.resumeContactInformation?.primaryAddress?.addressLine2,
                stateOrProvince: this.resumeContactInformation?.primaryAddress?.stateOrprovince,
                countryText: this.resumeContactInformation?.primaryAddress?.country,
                primaryManualCity: this.resumeContactInformation?.primaryAddress?.city,
              },
            },
          );
        }
      }
      if (this.$appSettings.dcoConfigurations.productsAllowedWithAccountDetails.includes(this.getProductType)) {
        if (this.savePersonalResponse.data.contactInformation === null) {
          this.formInput.data[this.personalInformationPage].correspondingAddress = 'true';
          this.formInput.data[this.personalInformationPage].addressPrevious = 'true';
          this.formInput.data[this.personalInformationPage].isAddressLookUpEnabled = addressLookupEnabled === true || addressLookupEnabled === 'true' ? 'true' : 'false';
        }
        if (this.savePersonalResponse.data.contactInformation !== null) {
          this.resumeContactInformation = this.applicantType === 'primary' ? JSON.parse(this.savePersonalResponse.data.contactInformation) : JSON.parse(this.savePersonalResponse.data.contactInformation)?.secondaryApplicantsContactInformation ? JSON.parse(this.savePersonalResponse.data.contactInformation)?.secondaryApplicantsContactInformation[0] : '';
          if (this.resumeContactInformation?.primaryAddress?.addressLine1 && this.resumeContactInformation?.primaryAddress?.addressLine1 !== '' && this.resumeContactInformation.primaryAddress.addressID && this.resumeContactInformation.primaryAddress.addressID !== '') {
            this.formInput.data[this.personalInformationPage].isAddressLookUpEnabled = 'true';
            this.formInput.data[this.personalInformationPage].correspondingAddress = (this.resumeContactInformation?.primaryAddress?.addressLine1 === this.resumeContactInformation?.correspondenceAddress?.addressLine1) ? 'true' : 'false';
            this.formInput.data[this.personalInformationPage].addressPrevious = this.resumeContactInformation && this.resumeContactInformation?.previousResidentialAddress ? this.resumeContactInformation?.previousResidentialAddress?.postCode && (this.resumeContactInformation?.primaryAddress?.addressLine1 === this.resumeContactInformation?.previousResidentialAddress?.addressLine1) ? 'true' : 'false' : 'true';
            this.formInput.data[this.personalInformationPage].postCode1 = this.resumeContactInformation?.primaryAddress?.addressID;
            if (this.formInput.data[this.personalInformationPage].postCode1 !== '') {
              this.formInput.data[this.personalInformationPage] = Object.assign(
                {},
                {
                  ...this.formInput.data[this.personalInformationPage],
                  ...{
                    primaryPostCode: this.resumeContactInformation?.primaryAddress.postCode,
                    primaryAddressId: this.resumeContactInformation?.primaryAddress.addressID,
                    primaryAddressLine1: this.resumeContactInformation?.primaryAddress.addressLine1,
                    primaryAddressLine2: this.resumeContactInformation?.primaryAddress.addressLine2,
                    primaryAddressLine3: this.resumeContactInformation?.primaryAddress.addressLine3,
                    primaryAddressLine4: this.resumeContactInformation?.primaryAddress.addressLine4,
                    addressLine5: this.resumeContactInformation?.primaryAddress.addressLine5,
                    addressLine6: this.resumeContactInformation?.primaryAddress.addressLine6,
                    primaryCountryCode: this.resumeContactInformation?.primaryAddress.countryCode,
                    residentialAddress: this.resumeContactInformation?.primaryAddress.addressText,
                    primaryCity: this.resumeContactInformation?.primaryAddress.city,
                    primaryStateOrprovince: this.resumeContactInformation?.primaryAddress?.stateOrprovince,
                    isDefault: (this.resumeContactInformation?.primaryAddress.isDefault === 'true' || this.resumeContactInformation?.primaryAddress.isDefault === true) ? 'true' : 'false',
                  },
                },
              );
            }
            if (this.formInput.data[this.personalInformationPage]?.correspondingAddress === 'false') {
              this.formInput.data[this.personalInformationPage] = Object.assign(
                {},
                {
                  ...this.formInput.data[this.personalInformationPage],
                  ...{
                    postCode11: this.resumeContactInformation?.correspondenceAddress.postCode,
                    addressId1: this.resumeContactInformation?.correspondenceAddress.addressID,
                    addressLine11: this.resumeContactInformation?.correspondenceAddress.addressLine1,
                    addressLine12: this.resumeContactInformation?.correspondenceAddress.addressLine2,
                    addressLine13: this.resumeContactInformation?.correspondenceAddress.addressLine3,
                    addressLine14: this.resumeContactInformation?.correspondenceAddress.addressLine4,
                    addressLine15: this.resumeContactInformation?.correspondenceAddress.addressLine5,
                    addressLine16: this.resumeContactInformation?.correspondenceAddress.addressLine6,
                    countryCode1: this.resumeContactInformation?.correspondenceAddress.countryCode,
                    correspondenceAddress: this.resumeContactInformation?.correspondenceAddress.addressText,
                    city1: this.resumeContactInformation?.correspondenceAddress.city,
                    correspondenceStateOrprovince: this.resumeContactInformation?.correspondenceAddress?.stateOrprovince,
                  },
                },
              );
            }
            if (this.formInput.data[this.personalInformationPage]?.addressPrevious === 'false') {
              this.formInput.data[this.personalInformationPage] = Object.assign(
                {},
                {
                  ...this.formInput.data[this.personalInformationPage],
                  ...{
                    postCode21: this.resumeContactInformation?.previousResidentialAddress.postCode,
                    addressId2: this.resumeContactInformation?.previousResidentialAddress.addressID,
                    addressLine21: this.resumeContactInformation?.previousResidentialAddress.addressLine1,
                    addressLine22: this.resumeContactInformation?.previousResidentialAddress.addressLine2,
                    addressLine23: this.resumeContactInformation?.previousResidentialAddress.addressLine3,
                    addressLine24: this.resumeContactInformation?.previousResidentialAddresss?.addressLine4,
                    addressLine25: this.resumeContactInformation?.previousResidentialAddress?.addressLine5,
                    addressLine26: this.resumeContactInformation?.previousResidentialAddress?.addressLine6,
                    countryCode2: this.resumeContactInformation?.previousResidentialAddress.countryCode,
                    city2: this.resumeContactInformation?.previousResidentialAddress.city,
                    previousResidentialAddress: this.resumeContactInformation?.previousResidentialAddress?.addressText,
                    previousStateOrprovince: this.resumeContactInformation?.previousResidentialAddress.stateOrprovince,
                    fromDate: moment(String(this.resumeContactInformation?.previousResidentialAddress.fromDate), 'YYYY-MM-DD').format(
                      'DD-MM-YYYY'),
                    toDate: moment(String(this.resumeContactInformation?.previousResidentialAddress.toDate), 'YYYY-MM-DD').format(
                      'DD-MM-YYYY'),
                  },
                },
              );
            }
          } else {
            this.formInput.data[this.personalInformationPage] = Object.assign(
              {},
              {
                ...this.formInput.data[this.personalInformationPage],
                ...{
                  isAddressLookUpEnabled: status && status?.data?.isAddressLookupEnabled ? 'true' : 'false',
                  manualAddressToggle: status && status?.data?.isAddressLookupEnabled && this.resumeContactInformation.primaryAddress?.addressID !== undefined && this.resumeContactInformation.primaryAddress?.addressID !== null && this.resumeContactInformation.primaryAddress?.addressID !== '' ? 'false' : 'true',
                  postCodeText: this.resumeContactInformation?.primaryAddress?.postCode,
                  AddressLine1: this.resumeContactInformation?.primaryAddress?.addressLine1,
                  AddressLine2: this.resumeContactInformation?.primaryAddress?.addressLine2,
                  stateOrProvince: this.resumeContactInformation?.primaryAddress?.stateOrprovince,
                  countryText: this.resumeContactInformation?.primaryAddress?.country,
                  primaryManualCity: this.resumeContactInformation?.primaryAddress?.city,
                  isDefaultManual: (this.resumeContactInformation?.primaryAddress?.isDefault === 'true' || this.resumeContactInformation?.primaryAddress?.isDefault === true) ? 'true' : 'false',
                  correspondingAddressText: !this.resumeContactInformation?.correspondenceAddress ? 'true' : this.resumeContactInformation?.primaryAddress?.addressLine1 === this.resumeContactInformation?.correspondenceAddress?.addressLine1 ? 'true' : 'false',
                  manualPrevAddress: this.resumeContactInformation && this.resumeContactInformation.previousResidentialAddress ? this.resumeContactInformation.primaryAddress.addressLine1 === this.resumeContactInformation?.previousResidentialAddress?.addressLine1 ? 'true' : 'false' : 'true',
                },
              },
            );

            if (this.formInput.data[this.personalInformationPage]?.correspondingAddressText === 'false') {
              this.formInput.data[this.personalInformationPage] = Object.assign(
                {},
                {
                  ...this.formInput.data[this.personalInformationPage],
                  ...{
                    postCodeText1: this.resumeContactInformation?.correspondenceAddress.postCode,
                    AddressLine11: this.resumeContactInformation?.correspondenceAddress.addressLine1,
                    AddressLine21: this.resumeContactInformation?.correspondenceAddress.addressLine2,
                    corrAddress3: this.resumeContactInformation?.correspondenceAddress.addressLine3,
                    corrAddressLine4: this.resumeContactInformation?.correspondenceAddress.addressLine4,
                    stateOrProvince1: this.resumeContactInformation?.correspondenceAddress.stateOrprovince,
                    corrCountryText: this.resumeContactInformation?.correspondenceAddress.country,
                    corrCity: this.resumeContactInformation?.correspondenceAddress.city,
                  },
                },
              );
            }
            if (this.formInput.data[this.personalInformationPage]?.manualPrevAddress === 'false') {
              this.formInput.data[this.personalInformationPage] = Object.assign(
                {},
                {
                  ...this.formInput.data[this.personalInformationPage],
                  ...{
                    postCodeText11: this.resumeContactInformation?.previousResidentialAddress.postCode,
                    AddressLine111: this.resumeContactInformation?.previousResidentialAddress.addressLine1,
                    AddressLine211: this.resumeContactInformation?.previousResidentialAddress.addressLine2,
                    prevAddressLine3: this.resumeContactInformation?.previousResidentialAddress.addressLine3,
                    prevAddressLine4: this.resumeContactInformation?.previousResidentialAddress.addressLine4,
                    stateOrProvince11: this.resumeContactInformation?.previousResidentialAddress.stateOrprovince,
                    prevCountryText: this.resumeContactInformation?.previousResidentialAddress.country,
                    prevCity: this.resumeContactInformation?.previousResidentialAddress.city,
                    addressFrom: this.resumeContactInformation?.previousResidentialAddress?.fromDate !== '' ? moment(String(this.resumeContactInformation?.previousResidentialAddress.fromDate), 'YYYY-MM-DD').format(
                      'DD-MM-YYYY') : '',
                    addressTo: this.resumeContactInformation?.previousResidentialAddress.toDate !== '' ? moment(String(this.resumeContactInformation?.previousResidentialAddress.toDate), 'YYYY-MM-DD').format(
                      'DD-MM-YYYY') : '',
                  },
                },
              );
            }
          }
        }
      }
      this.conditionalHide(1);
      if (this.applicantType === 'secondary' && (this.resumeContactInformation === undefined || this.resumeContactInformation === '' || this.resumeContactInformation?.primaryAddress?.addressLine1 === JSON.parse(this.saveResponse.data?.contactInformation)?.primaryAddress?.addressLine1)) {
        addressSameAsPrimary = true;
      }
      // addressSameAsPrimary === false is for exisitng flow for primary applicant.
      if (addressSameAsPrimary === false) {
        this.formInput.data[this.personalInformationPage].addressSameAsPrimary = 'false';
        this.formInput.data[this.personalInformationPage].manualAddressToggle = status && status?.data?.isAddressLookupEnabled && this.resumeContactInformation.primaryAddress?.addressID !== undefined && this.resumeContactInformation.primaryAddress?.addressID !== null && this.resumeContactInformation.primaryAddress?.addressID !== '' ? 'false' : 'true';
        if (this.formInput.data[this.personalInformationPage].isAddressLookUpEnabled === 'true' && this.formInput.data[this.personalInformationPage].manualAddressToggle === 'false') {
          this.dataObj.data.wizardSteps[pageBasedOnProducts[this.getProductType][this.applicantType]?.personalInformation[0]].components.forEach((component) => {
            if (component?.key === 'addressGrid' || component?.key === 'addressDateGrid') {
              component.hidden = false;
              component && component.components.forEach((subComponent) => {
                subComponent && subComponent.forEach((childComponent) => {
                  if (childComponent?.key === 'residentialAddress') {
                    childComponent.hidden = false;
                  }
                  if (childComponent?.key === 'previousResidentialAddress' || childComponent?.key === 'fromDate' || childComponent?.key === 'toDate') {
                    childComponent.hidden = !!(this.formInput.data[this.personalInformationPage]?.addressPrevious === 'true' || this.formInput.data[this.personalInformationPage]?.addressPrevious === true);
                  }
                });
              });
            }
          });
        } else if (this.formInput.data[this.personalInformationPage].isAddressLookUpEnabled === 'false' || (this.formInput.data[this.personalInformationPage].manualAddressToggle === 'true')) {
          this.dataObj.data.wizardSteps[pageBasedOnProducts[this.getProductType][this.applicantType]?.personalInformation[0]].components.forEach((component) => {
            if (component?.key === 'addressGrid' || component?.key === 'addressDateGrid') {
              component.hidden = true;
              component && component.components.forEach((subComponent) => {
                subComponent && subComponent.forEach((childComponent) => {
                  if (childComponent?.key === 'residentialAddress') {
                    childComponent.hidden = true;
                  }
                });
              });
            } else if (component?.key === 'manualAddressGrid') {
              component.hidden = false;
              component && component.components.forEach((subComponent) => {
                subComponent && subComponent.forEach((childComponent) => {
                  if (childComponent?.key === 'AddressLine1' || childComponent?.key === 'AddressLine2' || childComponent?.key === 'postCodeText' || childComponent?.key === 'countryText' || childComponent?.key === 'primaryManualCity' || childComponent?.key === 'stateOrProvince') {
                    childComponent.hidden = false;
                  }
                });
              });
            } else if (component?.key === 'manualDateGrid') {
              component && component.components.forEach((subComponent) => {
                subComponent && subComponent.forEach((childComponent) => {
                  if (childComponent?.key === 'addressFrom' || childComponent?.key === 'addressTo') {
                    childComponent.hidden = !!(this.formInput.data[this.personalInformationPage]?.manualPrevAddress === 'true' || this.formInput.data[this.personalInformationPage]?.addressPrevious === true);
                    component.hidden = !!(this.formInput.data[this.personalInformationPage]?.manualPrevAddress === 'true' || this.formInput.data[this.personalInformationPage]?.addressPrevious === true);
                  }
                });
              });
              component && component.components.forEach((subComponent) => {
                subComponent && subComponent.forEach((childComponent) => {
                  if (childComponent?.key === 'addressFrom' || childComponent?.key === 'addressTo') {
                    childComponent.hidden = !!(this.formInput.data[this.personalInformationPage]?.manualPrevAddress === 'true' || this.formInput.data[this.personalInformationPage]?.addressPrevious === true);
                    component.hidden = !!(this.formInput.data[this.personalInformationPage]?.manualPrevAddress === 'true' || this.formInput.data[this.personalInformationPage]?.addressPrevious === true);
                  }
                });
              });
            } else if (component?.key === 'primaryAddressGrid') {
              component && component.components.forEach((subComponent) => {
                subComponent && subComponent.forEach((childComponent) => {
                  if (childComponent?.key === 'manualAddressToggle') {
                    if (status && status.data && (status.data.isAddressLookupEnabled === false || status.data.isAddressLookupEnabled === 'false')) {
                      childComponent.disabled = true;
                      component.hidden = false;
                      this.formInput.data[this.personalInformationPage].manualAddressToggle = 'true';
                    } else if (this.formInput.data[this.personalInformationPage].manualAddressToggle === 'true') {
                      this.formInput.data[this.personalInformationPage].manualAddressToggle = 'true';
                      component.hidden = false;
                    }
                  }
                });
              });
            }
          });
        }
      } else if (addressSameAsPrimary === true) {
        if (this.formInput.data[this.personalInformationPage].isAddressLookUpEnabled === 'true') {
          this.formInput.data[this.personalInformationPage].manualAddressToggle = 'false';
        } else if (this.formInput.data[this.personalInformationPage].isAddressLookUpEnabled === 'false') {
          this.formInput.data[this.personalInformationPage].manualAddressToggle = 'true';
          this.dataObj.data.wizardSteps[pageBasedOnProducts[this.getProductType][this.applicantType]?.personalInformation[0]].components.forEach((component) => {
            if ((component?.key === 'addressGrid' || component?.key === 'addressDateGrid')) {
              component.hidden = true;
              component && component.components.forEach((subComponent) => {
                subComponent && subComponent.forEach((childComponent) => {
                  if (childComponent?.key === 'residentialAddress') {
                    childComponent.hidden = true;
                  }
                });
              });
            } else if (this.currentActionRoute !== 'secondaryApplicantOnboard' && component?.key === 'manualAddressGrid') {
              component.hidden = false;
              component && component.components.forEach((subComponent) => {
                subComponent && subComponent.forEach((childComponent) => {
                  if (childComponent?.key === 'AddressLine1' || childComponent?.key === 'AddressLine2' || childComponent?.key === 'postCodeText' || childComponent?.key === 'countryText' || childComponent?.key === 'primaryManualCity' || childComponent?.key === 'stateOrProvince') {
                    childComponent.hidden = false;
                  }
                });
              });
            } else if (this.currentActionRoute !== 'secondaryApplicantOnboard' && component?.key === 'manualDateGrid') {
              component && component.components.forEach((subComponent) => {
                subComponent && subComponent.forEach((childComponent) => {
                  if (childComponent?.key === 'addressFrom' || childComponent?.key === 'addressTo') {
                    childComponent.hidden = !!(this.formInput.data[this.personalInformationPage]?.manualPrevAddress === 'true' || this.formInput.data[this.personalInformationPage]?.addressPrevious === true);
                    component.hidden = !!(this.formInput.data[this.personalInformationPage]?.manualPrevAddress === 'true' || this.formInput.data[this.personalInformationPage]?.addressPrevious === true);
                  }
                });
              });
              component && component.components.forEach((subComponent) => {
                subComponent && subComponent.forEach((childComponent) => {
                  if (childComponent?.key === 'addressFrom' || childComponent?.key === 'addressTo') {
                    childComponent.hidden = !!(this.formInput.data[this.personalInformationPage]?.manualPrevAddress === 'true' || this.formInput.data[this.personalInformationPage]?.addressPrevious === true);
                    component.hidden = !!(this.formInput.data[this.personalInformationPage]?.manualPrevAddress === 'true' || this.formInput.data[this.personalInformationPage]?.addressPrevious === true);
                  }
                });
              });
            } else if (component?.key === 'primaryAddressGrid') {
              component && component.components.forEach((subComponent) => {
                subComponent && subComponent.forEach((childComponent) => {
                  if (childComponent?.key === 'manualAddressToggle') {
                    if (status && status.data && (status.data.isAddressLookupEnabled === false || status.data.isAddressLookupEnabled === 'false')) {
                      childComponent.disabled = true;
                    }
                  }
                });
              });
            }
          });
        }
      }
      if (this.applicantType === 'primary' && ['savings', 'termDeposit'].includes(this.getProductType)) {
        this.accountOwnershipDataSaved();
      }
    },
    accountOwnershipDataSaved() {
      const productInformation = JSON.parse(this.savePersonalResponse.data.productInformation);

      this.formInput.data.page2.initialSavedData = JSON.stringify(this.savePersonalResponse.data);
      this.formInput.data.page2.accountOwnership = productInformation?.accountOwnership;
      this.formInput.data.page2.modeOfOperation = productInformation?.modeOfOperation;

      if (this.formInput.data.page2.accountOwnership !== 'SOLE') {
        const wizardPage = this.dataObj.data.wizardSteps[1];

        // eslint-disable-next-line no-unused-expressions
        wizardPage?.components?.forEach((component) => {
          if (component.key === 'accountOwner') {
            component.hidden = false;
            if (component && component.components) {
              component.components.forEach((subComponent) => {
                if (subComponent) {
                  // eslint-disable-next-line no-unused-expressions
                  subComponent?.forEach((childComponent) => {
                    childComponent.hidden = false;
                  });
                }
              });
            }
          }
        });
      }
    },
    async additionalDetailsPartialData() {
      this.resumeEmploymentDetails = JSON.parse(this.savePersonalResponse.data.otherInformation);
      this.resumeAccountInformation = JSON.parse(this.savePersonalResponse.data.accountInformation);
      this.resumePersonalInformation = JSON.parse(this.savePersonalResponse.data.personalInformation);
      this.resumeProductInformation = JSON.parse(this.savePersonalResponse.data.productInformation);

      if (this.applicantType === 'secondary') {
        this.formInput.data[this.additionalInformationPage].b2bSessionId = this.savePersonalResponse?.data?.b2bSessionId;
        this.resumeEmploymentDetails = this.resumeEmploymentDetails?.secondaryApplicantsOtherInformation[0];
        this.resumePersonalInformation = this.resumePersonalInformation?.secondaryApplicantsPersonalInformation[0];
      }

      this.formInput.data[this.additionalInformationPage] = Object.assign(
        {},
        {
          ...this.formInput.data[this.additionalInformationPage],
          ...{
            employmentStatus: this.resumeEmploymentDetails?.employmentDetails?.employmentStatus || '',
            nameOfTheEmployer: this.resumeEmploymentDetails?.employmentDetails?.nameOfTheEmployer,
            employmentType: this.resumeEmploymentDetails?.employmentDetails?.employmentType,
            businessType: this.resumeEmploymentDetails?.employmentDetails?.businessType,
            jobTitle: this.resumeEmploymentDetails?.employmentDetails?.jobTitle,
            paymentMethod: this.resumeEmploymentDetails?.employmentDetails?.paymentMethod,
            paymentFrequency: this.resumeEmploymentDetails?.employmentDetails?.paymentFrequency,
            bankAccount: this.resumeAccountInformation?.isIBANAvailable || 'false',
            entityId: this.response.entityId,
            purposeOfAccount: this.resumeProductInformation?.purposeOfAccount || '',
            purposeOfAccountOthers: this.resumeProductInformation?.purposeOfAccountOthers || '',
            expectedUsage: this.resumeProductInformation?.expectedUsage || '',
            expectedTurnover: this.resumePersonalInformation?.expectedTurnover || '',
            sourceCountryOfFunds: this.resumePersonalInformation?.sourceCountryOfFunds || '',
            job: this.resumePersonalInformation?.job || '',
            udfBusinessType: this.resumePersonalInformation?.udfBusinessType || '',
            b2bSessionId: this.savePersonalResponse?.data?.b2bSessionId,
          },
        },
      );
      if (this.applicantType === 'primary') {
        this.formInput.data[this.additionalInformationPage] = Object.assign(
          {},
          {
            ...this.formInput.data[this.additionalInformationPage],
            ...{ ibanNumber: this.resumeAccountInformation?.iban,
              bankName: this.resumeAccountInformation?.bankName,
              ibanCurrency: this.formInput.data[this.additionalInformationPage].bankAccount === 'true' ? this.resumeAccountInformation?.currency : '',
              accountCurrency: 'GBP',
              sortCodeResult: this.resumeAccountInformation?.sortCode,
              bicCode: this.resumeAccountInformation?.bicCode,
              accountNumber: this.resumeAccountInformation?.accountNumber },
          },
        );
      }
      if (this.applicantType === 'secondary') {
        this.formInput.data[this.additionalInformationPage].relationshipType = this.resumeEmploymentDetails?.relationshipType || '';
      }
      if (this.applicantType === 'primary' && (this.getProductType === 'savings' || this.getProductType === 'termDeposit')) {
        this.conditionalHide(3);
      } else {
        this.conditionalHide(2);
      }
      if (this.applicantType === 'primary') {
        const wizardPage = this.dataObj.data.wizardSteps[pageBasedOnProducts[this.getProductType][this.applicantType]?.additionalInformation[0]];

        if (this.formInput.data[this.additionalInformationPage]?.bankAccount === 'true') {
          // eslint-disable-next-line no-unused-expressions
          wizardPage?.components.forEach((component) => {
            if (component) {
              if (component?.key === 'ibanToggle') {
                component.hidden = false;
              } else if (component?.key === 'accountNumberGrid') {
                component.hidden = true;
              } else if (component?.key === 'sortCheck') {
                component.hidden = true;
              }
            }
          });
        } else if (this.formInput.data[this.additionalInformationPage]?.bankAccount === 'false') {
          // eslint-disable-next-line no-unused-expressions
          wizardPage?.components.forEach((component) => {
            if (component) {
              if (component?.key === 'ibanToggle') {
                component.hidden = true;
              } else if (component?.key === 'accountNumberGrid') {
                component.hidden = false;
                if (component && component?.components) {
                  component.components.forEach((subComponent) => {
                    if (subComponent) {
                      subComponent.forEach((childComponent) => {
                        childComponent.hidden = false;
                      });
                    }
                  });
                }
              } else if (component?.key === 'sortCheck') {
                component.hidden = false;
                if (component && component?.components) {
                  component.components.forEach((subComponent) => {
                    if (subComponent) {
                      subComponent.forEach((childComponent) => {
                        if (childComponent?.key !== 'changeSortCode') {
                          childComponent.hidden = false;
                        }
                      });
                    }
                  });
                }
              }
            }
          });
        }

        const currencyGrid = this.dataObj.data.wizardSteps[pageBasedOnProducts[this.getProductType][this.applicantType]?.additionalInformation[0]].components;

        currencyGrid.forEach((element) => {
          if (element.key === 'currAndName') {
            element.components.forEach((subElement) => {
              subElement.forEach((childElement) => {
                childElement.hidden = this.formInput.data[this.additionalInformationPage].bankAccount === 'true' ? childElement.key === 'ibanCurrency' ? false : childElement.key === 'accountCurrency' ? true : childElement.hidden : childElement.hidden;
              });
            });
          }
        });
      }
      if (this.applicantType === 'primary' && ['savings', 'termDeposit'].includes(this.getProductType)) {
        this.accountOwnershipDataSaved();
      }
    },
    conditionalHide(index) {
      const dataObject = this.dataObj.data.wizardSteps[index].components;

      dataObject.forEach((data) => {
        if (data.components) {
          for (let components = 0; components < (data.components).length; components++) {
            const testData = data.components[components];

            for (let nestedComponents = 0; nestedComponents < testData.length; nestedComponents++) {
              const nestedData = testData[nestedComponents].key;
              if (nestedData === 'countryOfTaxResidentCode') {
                this.formInput.data.countryOfTaxResidentCode = this.resumeTaxInformation?.countryOfTaxResidentCode || testData[nestedComponents].defaultValue;
              }
              testData[nestedComponents].conditional.forEach((condition) => {
                const { custom, conditionAction = 'hide' } = condition;
                const eq = condition.eq;

                let customLogic = true;
                let hidden = false;
                if (custom) {
                  custom.forEach((cstm) => {
                    const updatedWithValues = cstm.logic.replaceAll(/{{(.*?)}}/g, (e) => {
                      const [stepName, componentKey] = e.slice(2, e.length - 3).split('[');
                      return this.formInput && this.formInput.data && this.formInput.data[stepName] && this.formInput.data[stepName][componentKey];
                    });
                    customLogic *= jsonLogic.apply(JSON.parse(updatedWithValues));
                  });
                }
                if (eq === this.formInput.data[this.personalInformationPage][nestedData]) {
                  hidden = !(condition.hidden);
                }
                if (customLogic === 0) {
                  if (conditionAction === 'hide') {
                    hidden = false;
                  } else if (conditionAction === 'disabled') {
                    condition.disabled = false;
                  }
                } else if (customLogic === 1) {
                  if (conditionAction === 'hide') {
                    hidden = true;
                  } else {
                    condition.disabled = true;
                  }
                }
                data.components[components].forEach((testing) => {
                  if (testing.key === condition.key && ((this.formInput.data[this.personalInformationPage][condition.key] !== '') || hidden === false)) {
                    if (testing.hidden === true) {
                      testing.hidden = testing.hidden !== hidden ? hidden : testing.hidden;
                    } else if (testing.disabled === true) {
                      testing.disabled = testing.disabled !== condition.disabled ? condition.disabled : testing.disabled;
                    }
                  } else {
                    const simpleConditionComponents = testing.conditional;

                    for (let index = 0; index <= simpleConditionComponents.length; index++) {
                      if (simpleConditionComponents[index]?.eq && simpleConditionComponents[index]?.eq !== '' && (testing.key === 'tax' || testing.key === 'bankAccount')) {
                        if (this.formInput.data[this.personalInformationPage][testing.key] !== simpleConditionComponents[index]?.eq && simpleConditionComponents[index].hide) {
                          dataObject.forEach((data) => {
                            if (data.components) {
                              for (let i = 0; i < (data.components).length; i++) {
                                for (let j = 0; j < data.components[i].length; j++) {
                                  if (data.components[i][j].key === simpleConditionComponents[index].key) {
                                    data.components[i][j].hidden = !data.components[i][j].hidden;
                                    data.components[i][j].hidden = this.formInput.data[this.personalInformationPage][testing.key] === 'true';
                                  }
                                }
                              }
                            }
                          });
                        } else if (this.formInput.data[this.personalInformationPage][testing.key] !== eq && !simpleConditionComponents[index].hide) {
                          dataObject.forEach((data) => {
                            if (data.components) {
                              for (let i = 0; i < (data.components).length; i++) {
                                for (let j = 0; j < data.components[i].length; j++) {
                                  if (data.components[i][j].key === simpleConditionComponents[index].key) {
                                    data.components[i][j].hidden = this.formInput.data[this.personalInformationPage][testing.key] !== 'true';
                                  }
                                }
                              }
                            }
                          });
                        }
                      }
                    }
                  }
                  dataObject.forEach((array) => {
                    if (condition.key === array.key) {
                      if (condition.eq === this.formInput.data[this.personalInformationPage][testData[nestedComponents].key]) {
                      } else if ((condition.hide === false || condition.hide === 'false') && condition.eq === 'true') {
                        if (condition.eq !== this.formInput.data[this.personalInformationPage][testData[nestedComponents].key]) {
                          array.hidden = !(array.hidden);
                        }
                      } else if ((condition.hide === true || condition.hide === 'true') && condition.eq === 'true') {
                        if (condition.eq !== this.formInput.data[this.personalInformationPage][testData[nestedComponents].key]) {
                          array.hidden = !(array.hidden);
                        }
                      } else if ((condition.disabled === false || condition.disabled === 'false') && condition.eq === 'true') {
                        if (condition.eq !== this.formInput.data[this.personalInformationPage][testData[nestedComponents].key]) {
                          array.disabled = !(array.disabled);
                        }
                      } else if ((condition.disabled === true || condition.disabled === 'true') && condition.eq === 'true') {
                        if (condition.eq !== this.formInput.data[this.personalInformationPage][testData[nestedComponents].key]) {
                          array.disabled = !(array.disabled);
                        }
                      }
                    }
                  });
                });
              });
            }
          }
        }
      });
    },
    async updateDataObjects(response, pageBasedOnProducts, fullResponse) {
      const statusInformation = JSON.parse(response.statusInformation);
      const otherInformation = JSON.parse(response.otherInformation);
      const localeSelected = localStorage.getItem('localeSelected');
      let IDVEnabled = false;

      this.personalInformationPage = pageBasedOnProducts ? pageBasedOnProducts[this.getProductType][this.applicantType].personalInformation[1] : '';
      this.additionalInformationPage = pageBasedOnProducts ? pageBasedOnProducts[this.getProductType][this.applicantType].additionalInformation[1] : '';
      this.formInput.data[this.personalInformationPage].identityVerificationEnabled1 = statusInformation?.identityVerificationEnabled;
      this.formInput.data[this.personalInformationPage].isAddressLookUpEnabled = otherInformation?.addressLookupEnabled;
      this.formInput.data[this.personalInformationPage].preferredLanguageCode = localeSelected;
      this.formInput.data[this.personalInformationPage].statusInformation = JSON.stringify(statusInformation);
      this.formInput.data[this.personalInformationPage].b2bSessionId = response?.b2bSessionId !== null && response?.b2bSessionId !== undefined ? response.b2bSessionId : fullResponse?.b2bSessionId;
      const personalInformationData = response;

      this.formInput.data[this.personalInformationPage].entityId1 = response.entityId;
      this.formInput.data[this.additionalInformationPage].entityId1 = response.entityId;
      this.formInput.additionalHelperData = this.$appSettings?.dcoConfigurations?.displayApplicationNumber ? response.applicationNumber : '';
      store.dispatch('userStore/setUserData', {
        personalInformationData,
      });
      if (this.currentActionRoute === 'secondaryApplicantOnboard') {
        IDVEnabled = localStorage.getItem('IDVEnabled');
      }
      // This is to hide and show IDV document fields based on flag received.
      if ((statusInformation && (statusInformation?.identityVerificationEnabled === false || statusInformation?.identityVerificationEnabled === 'false')) || (this.currentActionRoute === 'secondaryApplicantOnboard' && (IDVEnabled === 'false' || IDVEnabled === false))) {
        const idvWizard = this.dataObj.data.wizardSteps[pageBasedOnProducts[this.getProductType][this.applicantType]?.personalInformation[0]].components;

        idvWizard.forEach((grid) => {
          if (grid.key === 'identityGrid' || grid.key === 'taxGrid') {
            if (grid?.components && grid.components.length > 0) {
              for (let index = 0; index < grid.components.length; index++) {
                for (let subComponent = 0; subComponent < grid.components[index].length; subComponent++) {
                  if (grid.components[index][subComponent].type === 'file') {
                    grid.components[index][subComponent].hidden = false;
                  } else if (grid.components[index][subComponent].type === 'HTMLcontent' && grid.key !== 'taxGrid') {
                    grid.components[index][subComponent].hidden = false;
                  }
                }
              }
            }
          }
        });
      } else {
        const idvWizard = this.dataObj.data.wizardSteps[pageBasedOnProducts[this.getProductType][this.applicantType]?.personalInformation[0]].components;

        idvWizard.forEach((grid) => {
          if (grid.key === 'taxGrid') {
            if (grid?.components && grid.components.length > 0) {
              for (let index = 0; index < grid.components.length; index++) {
                for (let subComponent = 0; subComponent < grid.components[index].length; subComponent++) {
                  if (grid.components[index][subComponent].type === 'file') {
                    grid.components[index][subComponent].hidden = true;
                  }
                }
              }
            }
          }
        });
      }
      // This is to hide and show address lookup based on flag received.
      if (otherInformation?.addressLookupEnabled === false && this.currentActionRoute !== 'secondaryApplicantOnboard') {
        this.formInput.data[pageBasedOnProducts[this.getProductType][this.applicantType]?.personalInformation[1]].manualAddressToggle = 'true';
        this.dataObj.data.wizardSteps[pageBasedOnProducts[this.getProductType][this.applicantType]?.personalInformation[0]].components.forEach((component) => {
          if ((component?.key === 'addressGrid' || component?.key === 'addressDateGrid')) {
            component.hidden = true;
            component && component.components.forEach((subComponent) => {
              subComponent && subComponent.forEach((childComponent) => {
                if (childComponent?.key === 'residentialAddress') {
                  childComponent.hidden = true;
                }
              });
            });
          } else if (component?.key === 'manualAddressGrid') {
            component.hidden = false;
            component && component.components.forEach((subComponent) => {
              subComponent && subComponent.forEach((childComponent) => {
                if (childComponent?.key === 'AddressLine1' || childComponent?.key === 'AddressLine2' || childComponent?.key === 'postCodeText' || childComponent?.key === 'countryText' || childComponent?.key === 'primaryManualCity') {
                  childComponent.hidden = false;
                }
              });
            });
          } else if (component?.key === 'manualDateGrid') {
            component && component.components.forEach((subComponent) => {
              subComponent && subComponent.forEach((childComponent) => {
                if (childComponent?.key === 'addressFrom' || childComponent?.key === 'addressTo') {
                  childComponent.hidden = !!(this.formInput.data[this.personalInformationPage]?.manualPrevAddress === 'true' || this.formInput.data[this.personalInformationPage]?.addressPrevious === true);
                  component.hidden = !!(this.formInput.data[this.personalInformationPage]?.manualPrevAddress === 'true' || this.formInput.data[this.personalInformationPage]?.addressPrevious === true);
                }
              });
            });
            component && component.components.forEach((subComponent) => {
              subComponent && subComponent.forEach((childComponent) => {
                if (childComponent?.key === 'addressFrom' || childComponent?.key === 'addressTo') {
                  childComponent.hidden = !!(this.formInput.data[this.personalInformationPage]?.manualPrevAddress === 'true' || this.formInput.data[this.personalInformationPage]?.addressPrevious === true);
                  component.hidden = !!(this.formInput.data[this.personalInformationPage]?.manualPrevAddress === 'true' || this.formInput.data[this.personalInformationPage]?.addressPrevious === true);
                }
              });
            });
          } else if (component?.key === 'primaryAddressGrid') {
            component && component.components.forEach((subComponent) => {
              subComponent && subComponent.forEach((childComponent) => {
                if (childComponent?.key === 'manualAddressToggle') {
                  childComponent.disabled = true;
                }
              });
            });
          }
        });
      } else if (otherInformation?.addressLookupEnabled === false && this.currentActionRoute === 'secondaryApplicantOnboard') {
        this.formInput.data[pageBasedOnProducts[this.getProductType][this.applicantType]?.personalInformation[1]].manualAddressToggle = 'true';
        this.formInput.data.page2.addressSameAsPrimary = 'true';
        this.dataObj.data.wizardSteps[pageBasedOnProducts[this.getProductType][this.applicantType]?.personalInformation[0]].components.forEach((component) => {
          if ((component?.key === 'addressGrid' || component?.key === 'addressDateGrid')) {
            component.hidden = true;
            component && component.components.forEach((subComponent) => {
              subComponent && subComponent.forEach((childComponent) => {
                if (childComponent?.key === 'residentialAddress') {
                  childComponent.hidden = true;
                }
              });
            });
          } else if (component?.key === 'primaryAddressGrid') {
            component && component.components.forEach((subComponent) => {
              subComponent && subComponent.forEach((childComponent) => {
                if (childComponent?.key === 'manualAddressToggle') {
                  childComponent.disabled = true;
                }
              });
            });
          }
        });
      }
    },
    getRouteInformation(accountType, dataObj, saveResponseData) {
      let route = {};
      this.saveResponseData = saveResponseData;

      const productMapping = store?.getters['userStore/userData']?.productInfo;
      const productInformation = JSON.parse(this.saveResponse?.data?.productInformation);
      const statusInformation = JSON.parse(this.saveResponse?.data?.statusInformation);
      const contactInformation = this.saveResponse.data.contactInformation !== null ? JSON.parse(this.saveResponse.data.contactInformation) : null;
      const taxInformation = JSON.parse(this.saveResponse.data.taxInformation);
      const personalInformation = JSON.parse(this.saveResponse?.data?.personalInformation);
      const otherInformation = JSON.parse(this.saveResponse?.data?.otherInformation);
      const accountInformation = this.saveResponse.data.accountInformation !== null ? JSON.parse(this.saveResponse?.data?.accountInformation) : null;
      const employmentDetailsObject = []; const arrayOfEmploymentDetailsHavingData = [];
      const contactListOfDataWithAddressLookup = ['addressID', 'postCode', 'addressLine1', 'country'];
      const contactListOfDataWithoutAddressLookup = ['postCode', 'addressLine1', 'country', 'city'];

      let personalListData = ['titleCode', 'firstName', 'lastName', 'gender', 'birthCountryCode', 'dateOfBirth', 'primaryNationality', 'nationalIdTypeId', 'nationalIdNumber'];
      let taxListData = ['taxIdentificationNumber', 'countryOfTaxResidentCode'];
      let taxPayerInOtherCountryListData = ['tinNumberInOtherCountry', 'foreignCountryOfTaxResidence'];
      let complianceListOfData = ['expectedTurnover', 'sourceCountryOfFunds', 'job', 'udfBusinessType'];
      let productListOfData = ['purposeOfAccount', 'expectedUsage'];
      const contactListOfData = this.saveResponse?.data?.otherInformation?.addressLookupEnabled ? contactListOfDataWithAddressLookup : contactListOfDataWithoutAddressLookup;
      const personalScreenDataObj = dataObj && dataObj.data && dataObj.data.wizardSteps[pageBasedOnProducts[this.getProductType][accountType]?.personalInformation[0]].components;
      const mandatoryFields = [];
      const additionalMandatoryFields = [];
      const employmentDetails = this.applicantType === 'primary' ? otherInformation : otherInformation?.secondaryApplicantsOtherInformation ? otherInformation?.secondaryApplicantsOtherInformation[0] : null;

      personalScreenDataObj && personalScreenDataObj.forEach((component) => {
        if (component && component?.type === 'grid') {
          if (component?.components && component?.components.length > 0) {
            // eslint-disable-next-line no-unused-expressions
            component?.components.forEach((subComponent) => {
              if (subComponent && subComponent.length > 0) {
                subComponent.forEach((childComponent) => {
                  if (childComponent && childComponent?.validate && childComponent?.validate?.required) {
                    mandatoryFields.push(childComponent?.key);
                  }
                });
              }
            });
          }
        }
      });
      personalListData = mandatoryFields.filter((field) => personalListData.includes(field));
      taxListData = mandatoryFields.filter((field) => taxListData.includes(field));
      taxPayerInOtherCountryListData = mandatoryFields.filter((field) => taxPayerInOtherCountryListData.includes(field));
      dataObj = dataObj.data.wizardSteps[pageBasedOnProducts[this.getProductType][accountType]?.additionalInformation[0]].components;
      dataObj.forEach((element) => {
        if (element.key === 'employmentDetails') {
          element.components.forEach((subElement) => {
            subElement.forEach((data) => {
              if (data.type !== 'HTMLcontent' && data?.validate?.required) {
                employmentDetailsObject.push(data.key);
              }
            });
          });
        }
      });
      employmentDetailsObject.forEach((element) => {
        if (employmentDetails && employmentDetails !== undefined && employmentDetails?.employmentDetails && employmentDetails?.employmentDetails !== null &&
        Object.keys(employmentDetails.employmentDetails).includes(element) && (employmentDetails.employmentDetails[element] !== '' &&
        employmentDetails.employmentDetails[element] !== null)) {
          arrayOfEmploymentDetailsHavingData.push(true);
        }
      });
      dataObj && dataObj.forEach((component) => {
        if (component && component?.type === 'grid') {
          if (component?.components && component?.components.length > 0) {
            // eslint-disable-next-line no-unused-expressions
            component?.components.forEach((subComponent) => {
              if (subComponent && subComponent.length > 0) {
                subComponent.forEach((childComponent) => {
                  if (childComponent && childComponent?.validate && childComponent?.validate?.required) {
                    additionalMandatoryFields.push(childComponent?.key);
                  }
                });
              }
            });
          }
        }
      });
      complianceListOfData = additionalMandatoryFields.filter((field) => complianceListOfData.includes(field));
      productListOfData = additionalMandatoryFields.filter((field) => productListOfData.includes(field));
      if (productInformation && productInformation?.purposeOfAccount === 'ACCPURPOSE7') {
        productListOfData.push('purposeOfAccountOthers');
      }

      if (accountType === 'primary') {
        let personalPartiallyFilledDataCheck = false;
        let additionalPartiallyFilledDataCheck = false;
        let accNumRequired = false;
        let sortCodeRequired = false;
        let bankNameRequired = false;
        let ibanNum = false;
        let bicCode = false;
        let ibanBankName = false;
        let iCurrency = false;

        dataObj && dataObj.forEach((component) => {
          if (component && (component.key === 'ibanToggle' || component.key === 'currAndName')) {
            component && component.components.forEach((subComponent) => {
              subComponent && subComponent.forEach(async(childComponent) => {
                if (childComponent && (childComponent.key === 'ibanNumber')) {
                  ibanNum = childComponent?.validate.required;
                }
                if (childComponent && (childComponent.key === 'bicCode')) {
                  bicCode = childComponent?.validate.required;
                }
                if (childComponent && (childComponent.key === 'bankName')) {
                  ibanBankName = childComponent?.validate.required;
                }
                if (childComponent && (childComponent.key === 'ibanCurrency')) {
                  iCurrency = childComponent?.validate.required;
                }
              });
            });
          } else if (component && (component.key === 'accountNumberGrid' || component.key === 'sortCheck' || component.key === 'currAndName')) {
            component && component.components.forEach((subComponent) => {
              subComponent && subComponent.forEach(async(childComponent) => {
                if (childComponent && (childComponent.key === 'accountNumber')) {
                  accNumRequired = childComponent?.validate.required;
                }
                if (childComponent && (childComponent.key === 'sortCodeResult')) {
                  sortCodeRequired = childComponent?.validate.required;
                }
                if (childComponent && (childComponent.key === 'bankName')) {
                  bankNameRequired = childComponent?.validate.required;
                }
              });
            });
          }
        });

        const bankAccountTrue = ibanNum && bicCode && ibanBankName && iCurrency;
        const bankAccountFalse = accNumRequired && sortCodeRequired && bankNameRequired;
        const bankAccountTruePartiallyFilledCheck = bankAccountTrue && (this.saveResponse.data.accountInformation === null || this.saveResponse.data.accountInformation === '' || (accountInformation?.isIBANAvailable === 'true' && (accountInformation?.bicCode === '' || accountInformation?.currency === '')));
        const bankAccountFalsePartiallyFilledCheck = bankAccountFalse && (this.saveResponse.data.accountInformation === null || this.saveResponse.data.accountInformation === '' || (accountInformation?.isIBANAvailable === 'false' && (accountInformation?.sortCode === '' || accountInformation?.currency === '')));

        personalPartiallyFilledDataCheck = this.saveResponse && this.saveResponse.data && this.saveResponse.data.personalInformation !== null && ((this.checkPreFilledDataCount(personalListData, personalInformation) !== 0) ||
          (this.checkPreFilledDataCount(contactListOfData, contactInformation?.primaryAddress) !== 0) ||
          ((taxInformation && taxInformation?.taxPayerFlag === 'true' && (this.checkPreFilledDataCount(taxListData, taxInformation) !== 0 ||
          (taxInformation?.taxPayerFlag === 'true' && taxInformation?.taxResidentInOtherCountry === 'true' &&
            this.checkPreFilledDataCount(taxPayerInOtherCountryListData, taxInformation) !== 0))) ||
            (taxInformation?.taxPayerFlag === 'false' && mandatoryFields.includes('taxExemptionReason') && taxInformation?.taxExemptionReason === '')) ||
            (statusInformation !== null && statusInformation.identityVerificationEnabled === false && (this.identityDocuments.data.length < 3)));

        additionalPartiallyFilledDataCheck = this.saveResponse && this.saveResponse.data &&
        (bankAccountTruePartiallyFilledCheck || bankAccountFalsePartiallyFilledCheck ||
        (otherInformation?.employmentDetails === undefined || otherInformation?.employmentDetails === null || otherInformation?.employmentDetails?.employmentStatus === '' ||
          (this.$appSettings.dcoConfigurations.allowedEmploymentStatusReference.includes(otherInformation?.employmentDetails?.employmentStatus) &&
          employmentDetailsObject.length > arrayOfEmploymentDetailsHavingData.length)) || this.checkPreFilledDataCount(complianceListOfData, personalInformation) !== 0 || this.checkPreFilledDataCount(productListOfData, productInformation) !== 0);

        if (['savings', 'termDeposit'].includes(this.getProductType) && (productInformation?.accountOwnership === '' && productInformation?.modeOfOperation === '' &&
          (productMapping?.data?.applicableAccountOperationType === 'BOTH' || productMapping?.data?.applicableAccountOperationType === 'JOINT'))) {
          const personalInformationData = this.saveResponse.data;

          store.dispatch('userStore/setUserData', {
            personalInformationData,
          });
          route = {
            action: 'productOnboard',
            query: { type: 'AccountInformation' },
          };
        } else if (this.saveResponse && this.saveResponse.data && (this.saveResponse.data.personalInformation === null ||
          this.saveResponse.data.personalInformation === '')) {
          const personalInformationData = this.saveResponse.data;

          store.dispatch('userStore/setUserData', {
            personalInformationData,
          });
          route = {
            action: 'productOnboard',
            query: { type: 'PersonalInformation' },
          };
        } else if ((personalPartiallyFilledDataCheck || (this.getProductType === 'lifetimeISA' && !this.lisaEligibilityPassed))) {
          const personalInformationData = this.saveResponse.data;

          store.dispatch('userStore/setUserData', {
            personalInformationData,
          });
          route = {
            action: 'productOnboard',
            query: { type: 'PersonalInformation' },
          };
        } else if (additionalPartiallyFilledDataCheck) {
          const additionalInfoData = this.saveResponse.data;

          store.dispatch('userStore/setUserData', {
            additionalInfoData,
          });
          route = {
            action: 'productOnboard',
            query: { type: 'AdditionalInformation' },
          };
        } else if (
          (this.saveResponse && this.saveResponse.data && this.saveResponse.data.personalInformation !== null &&
              this.saveResponse.data.accountInformation !== null &&
              this.saveResponse.data.otherInformation !== null) || ((this.getProductType === 'currentAccount' || this.getProductType === 'savings') && this.saveResponse.data.personalInformation !== null &&
              this.saveResponse.data.otherInformation !== null)
        ) {
          const additionalInfoData = this.saveResponse.data;

          store.dispatch('userStore/setUserData', {
            additionalInfoData,
          });
          route = {
            action: 'ReviewInformation',
          };
        }
      } else if (accountType === 'secondary') {
        if (personalInformation && (personalInformation?.secondaryApplicantsPersonalInformation === undefined || personalInformation?.secondaryApplicantsPersonalInformation === null)) {
          const personalInformationData = this.saveResponse.data;

          store.dispatch('userStore/setUserData', {
            personalInformationData,
          });
          route = {
            action: 'secondaryEligibilityCheck',
          };
        } else {
          if (this.saveResponse && this.saveResponse.data && this.saveResponse.data.personalInformation && ((personalInformation?.secondaryApplicantsPersonalInformation.length === 0 ||
          this.checkPreFilledDataCount(personalListData, personalInformation?.secondaryApplicantsPersonalInformation[0]) !== 0) ||
          (contactInformation?.secondaryApplicantsContactInformation?.length === 0 ||
          this.checkPreFilledDataCount(contactListOfData, contactInformation?.secondaryApplicantsContactInformation?.[0]?.primaryAddress) !== 0 ||
          (contactInformation?.secondaryApplicantsContactInformation?.[0]?.correspondenceAddress !== undefined && this.checkPreFilledDataCount(contactListOfData, contactInformation?.secondaryApplicantsContactInformation?.[0]?.correspondenceAddress) !== 0)) ||
          (taxInformation?.secondaryApplicantsTaxInformation?.length === 0 ||
          (taxInformation?.secondaryApplicantsTaxInformation[0].taxPayerFlag === 'true' &&
          this.checkPreFilledDataCount(taxListData, taxInformation?.secondaryApplicantsTaxInformation[0]) !== 0) ||
          (taxInformation?.secondaryApplicantsTaxInformation[0].taxPayerFlag === 'true' &&
          taxInformation?.secondaryApplicantsTaxInformation[0].taxResidentInOtherCountry === 'true' &&
          this.checkPreFilledDataCount(taxPayerInOtherCountryListData, taxInformation?.secondaryApplicantsTaxInformation[0]) !== 0) || (taxInformation?.secondaryApplicantsTaxInformation[0].taxPayerFlag.toString() === 'false' && taxInformation?.secondaryApplicantsTaxInformation[0].taxExemptionReason === '')))) {
            const personalInformationData = this.saveResponse.data;

            store.dispatch('userStore/setUserData', {
              personalInformationData,
            });
            route = {
              action: 'secondaryApplicantOnboard',
              query: { type: 'PersonalInformation' },
            };
          } else if ((otherInformation && (otherInformation.secondaryApplicantsOtherInformation === undefined || otherInformation?.secondaryApplicantsOtherInformation.length === 0 || otherInformation?.secondaryApplicantsOtherInformation[0]?.relationshipType === '' ||
            otherInformation?.secondaryApplicantsOtherInformation[0]?.employmentDetails?.employmentStatus === '' ||
            (this.$appSettings.dcoConfigurations.allowedEmploymentStatusReference.includes(otherInformation?.secondaryApplicantsOtherInformation[0]?.employmentDetails?.employmentStatus) &&
            employmentDetailsObject.length > arrayOfEmploymentDetailsHavingData.length))) || this.checkPreFilledDataCount(complianceListOfData, personalInformation?.secondaryApplicantsPersonalInformation[0]) !== 0) {
            const personalInformationData = this.saveResponse.data;

            store.dispatch('userStore/setUserData', {
              personalInformationData,
            });
            route = {
              action: 'secondaryApplicantOnboard',
              query: { type: 'AdditionalInformation' },
            };
          } else {
            const additionalInfoData = this.saveResponse.data;

            store.dispatch('userStore/setUserData', {
              additionalInfoData,
            });
            route = {
              action: 'ReviewInformation',
            };
          }
        }

        return route;
      }
      return route;
    },
    async updateWatchFunctions(newVal) {
      if (this.currentActionRoute === 'eligibilityCheck') {
        if (this.dataObj !== undefined) {
          if (
            newVal.data?.areYouAUKResident !== '' &&
            newVal.data?.legalAgeFlag !== '' &&
            newVal.data?.anotherBankAccountAvailabilityFlag !== '' && (this.getProductType !== 'lifetimeISA' ||
            (this.getProductType === 'lifetimeISA' && newVal.data?.isLisaTransferIn !== ''))
          ) {
            // eslint-disable-next-line no-unused-expressions
            this.dataObj && this.dataObj.data && this.dataObj.data?.components.forEach((component) => {
              component && component.components.forEach((subComponent) => {
                subComponent && subComponent.forEach((childComponent) => {
                  if (childComponent && childComponent.key === 'confirmButton') {
                    childComponent.disabled = false;
                  }
                });
              });
            });
          } else {
            // eslint-disable-next-line no-unused-expressions
            this.dataObj && this.dataObj.data && this.dataObj.data?.components.forEach((component) => {
              component && component.components.forEach((subComponent) => {
                subComponent && subComponent.forEach((childComponent) => {
                  if (childComponent && childComponent.key === 'confirmButton') {
                    childComponent.disabled = true;
                  }
                });
              });
            });
          }
        }
      } else if (this.currentActionRoute === 'secondaryEligibilityCheck') {
        if (this.dataObj !== undefined) {
          if (newVal.data?.areYouAUKResident !== '' && newVal.data?.legalAgeFlag !== '') {
            // eslint-disable-next-line no-unused-expressions
            this.dataObj && this.dataObj.data && this.dataObj.data?.components.forEach((component) => {
              // eslint-disable-next-line no-unused-expressions
              component && component?.components.forEach((subComponent) => {
                subComponent && subComponent.forEach((childComponent) => {
                  if (childComponent && childComponent.key === 'confirmButton') {
                    childComponent.disabled = false;
                  }
                });
              });
            });
          } else {
            // eslint-disable-next-line no-unused-expressions
            this.dataObj && this.dataObj.data && this.dataObj.data?.components.forEach((component) => {
              // eslint-disable-next-line no-unused-expressions
              component && component?.components.forEach((subComponent) => {
                subComponent && subComponent.forEach((childComponent) => {
                  if (childComponent && childComponent.key === 'confirmButton') {
                    childComponent.disabled = true;
                  }
                });
              });
            });
          }
        }
      } else if (this.currentActionRoute === 'productOnboard') {
        const productMapping = store?.getters['userStore/userData']?.productInfo;
        const productData = productMapping?.data;
        const localeSelected = localStorage.getItem('localeSelected');
        const b2bSessionId = store?.getters['userStore/userData']?.b2bSessionId;

        this.personalInformationPage = pageBasedOnProducts?.[this.getProductType]?.primary?.personalInformation[1] || '';
        this.additionalInformationPage = pageBasedOnProducts?.[this.getProductType]?.primary?.additionalInformation[1] || '';

        // Configure page1 form data
        Object.assign(this.formInput.data.page1, {
          productId: productData?.productCode,
          currencyCode: productData?.currencyCode,
          module: productData?.module,
          productTypeCode: this.apiProductType.toLowerCase(),
          isEndDateCommonForAllAccounts: productData?.isEndDateCommonForAllAccounts,
          productEndDate: productData?.productEndDate,
          b2bSessionId: b2bSessionId,
          productSubType: this.getProductType,
        });

        // Configure personalInformationPage form data
        Object.assign(this.formInput.data[this.personalInformationPage], {
          displayProductType: this.getProductType.toLowerCase(),
          productType: this.apiProductType.toLowerCase(),
          preferredLanguageCode: localeSelected,
          b2bSessionId: b2bSessionId,
        });

        this.formInput.data[this.additionalInformationPage].b2bSessionId = b2bSessionId;

        // Set defaults for savings/termDeposit
        if (['savings', 'termDeposit'].includes(this.getProductType)) {
          this.formInput.data.page2.b2bSessionId = b2bSessionId;
          const isSoleAccount = ['SOLE', 'SINGLE'].includes(productData?.applicableAccountOperationType);

          Object.assign(this.formInput.data.page1, {
            defaultModeOfOperation: isSoleAccount ? 'SOLE' : '',
            defaultAccountOwnership: isSoleAccount ? 'SOLE' : '',
            applicableAccountOperationType: productData?.applicableAccountOperationType,
          });
        }
        this.formInput.data.page1.productSubType = this.getProductType;

        // Set LISA transfer validation
        if (this.getProductType === 'lifetimeISA') {
          const isTransferIn = localStorage.getItem('isLisaTransferInWithAgeCheck');

          if (isTransferIn !== null) {
            this.formInput.data.page1.lisaTransferInWithAgeValidation = isTransferIn;
            this.formInput.data[this.personalInformationPage].isTransferInWithAgeCheck = isTransferIn;
          }
        }

        // Validate form and enable/disable submit button
        if (this.dataObj?.data?.wizardSteps?.[0]) {
          const hasRequiredFields = newVal?.data?.page1?.mobilePhoneNumber && newVal?.data?.page1?.emailId;

          if (!hasRequiredFields) {
            this.dataObj.data.wizardSteps[0].components[3].components[0][0].disabled = true;
          } else {
            this.validateFormFields(newVal);
            if (newVal?.data?.page1?.mobilePhoneNumber !== '' && newVal?.data?.page1?.mobilePhoneNumber !== undefined) {
              // eslint-disable-next-line no-unused-expressions
              this.dataObj && this.dataObj.data && this.dataObj.data.wizardSteps && this.dataObj.data.wizardSteps[0]?.components.forEach((component) => {
                if (component?.key === 'grid') {
                  component && component.components.forEach((subComponent) => {
                    subComponent.forEach((childComponent) => {
                      if (childComponent?.key === 'mobilePhoneNumber') {
                        if (childComponent?.error === false) {
                          this.mobileNumberValid = true;
                        } else if (childComponent?.error === true) {
                          this.mobileNumberValid = false;
                          if (childComponent?.['error-messages'].length > 0) {
                            this.displaySnackBar({ title: this.$t('messages.error'), content: childComponent['error-messages'].join(', '), type: 'error' });
                          } else {
                            this.displaySnackBar({ title: this.$t('messages.error'), content: this.$t('messages.invalidPhoneNumber'), type: 'error' });
                          }
                          this.dataObj.data.wizardSteps[0].components[3].components[0][0].disabled = true;
                        }
                      }
                    });
                  });
                }
              });
            }
          }
        }
      } else if (this.currentActionRoute === 'resume') {
        if (this.formInput.data?.mobilePhoneNumber === '' || this.formInput.data?.mobilePhoneNumber === undefined) {
          this.dataObj.data.components[4].components[0][0].disabled = true;
        } else {
          this.dataObj.data.components.forEach((component) => {
            if (component?.key === 'grid') {
              component && component.components.forEach((subComponent) => {
                subComponent.forEach((childComponent) => {
                  if (childComponent?.key === 'mobilePhoneNumber') {
                    if (childComponent?.error === true) {
                      if (childComponent?.['error-messages'].length > 0) {
                        this.displaySnackBar({ title: this.$t('messages.error'), content: childComponent['error-messages'].join(', '), type: 'error' });
                      } else {
                        this.displaySnackBar({ title: this.$t('messages.error'), content: this.$t('messages.invalidPhoneNumber'), type: 'error' });
                      }
                      this.dataObj.data.components[4].components[0][0].disabled = true;
                    }
                  }
                });
              });
            }
          });
        }
        this.$forceUpdate();
        if (this.formInput.data.card === 'true' && this.formInput.data.card2 === 'true') {
          this.dataObj.data.components[1].components[1][0].disabled = true;
          this.dataObj.data.components[5].components[0][0].disabled = true;
          this.displaySnackBar({ title: this.$t('messages.error'), content: this.$t('messages.save.oneProduct'), type: 'error' });
        } else if (
          this.formInput.data.card === 'true' ||
          this.formInput.data.card2 === 'true'
        ) {
          this.dataObj.data.components[1].components[1][0].disabled = false;
          this.dataObj.data.components[5].components[0][0].disabled = false;
        } else if (
          this.formInput.data.card === 'false' ||
          this.formInput.data.card2 === 'false'
        ) {
          this.dataObj.data.components[1].components[1][0].disabled = true;
          this.dataObj.data.components[5].components[0][0].disabled = true;
        }
      } else if (this.currentActionRoute === 'otpVerification') {
        const mobileNumber = localStorage.getItem('mobileNumber') ? JSON.parse(localStorage.getItem('mobileNumber')) : store.getters['userStore/userData']?.mobileNumber;
        const productMapping = store?.getters['userStore/userData']?.productInfo;

        this.formInput.data.productType = this.apiProductType.toLowerCase();
        this.formInput.data.productCode = productMapping?.data?.productCode;
        if (this.formInput?.data?.digitalOtp === null || this.formInput.data.digitalOtp === '' || this.formInput.data.digitalOtp === undefined) {
          this.dataObj && this.dataObj.data && this.dataObj.data.components && this.dataObj.data.components.forEach((component) => {
            if (component.key === 'grid') {
              for (let index = 0; index < component.components.length; index++) {
                component.components[index].forEach((subComponent) => {
                  if (subComponent.key === 'continue') {
                    subComponent.disabled = true;
                  }
                });
              }
            }
          });
        } else if (this.formInput?.data?.digitalOtp !== null || this.formInput.data.digitalOtp !== '' || this.formInput.data.digitalOtp !== undefined) {
          localStorage.setItem('resumeOTP', this.formInput.data.digitalOtp);
          this.formInput.data.otp = this.formInput.data.digitalOtp;
          this.dataObj && this.dataObj.data && this.dataObj.data.components && this.dataObj.data.components.forEach((component) => {
            if (component.key === 'grid') {
              for (let index = 0; index < component.components.length; index++) {
                component.components[index].forEach((subComponent) => {
                  if (subComponent.key === 'continue') {
                    subComponent.disabled = false;
                  }
                });
              }
            }
          });
        }
        this.formInput.data.mobileCountryCode = mobileNumber.mobileCountryCode;
        this.formInput.data.mobilePhoneNumber = mobileNumber.mobilePhoneNumber;
        this.formInput.data.mobileFormattedCode = mobileNumber.mobileCountryCode.replaceAll(
          '+',
          '%2B',
        );
        this.formInput.data.b2bSessionId = store?.getters['userStore/userData']?.b2bSessionId;
        if (newVal && newVal.data && newVal.data.referenceCode === '') {
          this.formInput.data.referenceCode = localStorage.getItem('referenceCode');
        }
      } else if (this.currentActionRoute === 'otpVerificationProduct') {
        const mobileNumber = localStorage.getItem('mobileNumber') ? JSON.parse(localStorage.getItem('mobileNumber')) : store.getters['userStore/userData']?.mobileNumber;

        this.formInput.data.otp = localStorage.getItem('resumeOTP');
        this.formInput.data.mobileCountryCode = mobileNumber.mobileCountryCode;
        this.formInput.data.mobilePhoneNumber = mobileNumber.mobilePhoneNumber;
        this.formInput.data.mobileFormattedCode = mobileNumber.mobileCountryCode.replaceAll(
          '+',
          '%2B',
        );
        if (newVal && newVal.data && newVal.data.referenceCode === '') {
          this.formInput.data.referenceCode = localStorage.getItem('referenceCode');
        }
        const productValidationResponse = JSON.parse(
          localStorage.getItem('productValidationResponse'),
        );

        this.formInput.data.b2bSessionId = productValidationResponse?.b2bSessionId ? productValidationResponse.b2bSessionId : store?.getters['userStore/userData']?.b2bSessionId;

        if (productValidationResponse && productValidationResponse.productDetails && productValidationResponse.productDetails[1].errorMessage && (productValidationResponse.productDetails[1].errorMessage.includes('Invalid product information. Failed to fetch product details') || productValidationResponse.productDetails[1].errorMessage.includes('Your previously chosen product is no longer available or invalid.'))) {
          this.dataObj.data.components[0].components[2][0].hidden = true;
          this.dataObj.data.components[0].components[3][0].hidden = false;
          this.dataObj && this.dataObj.data && this.dataObj.data.components && this.dataObj.data.components.forEach((components) => {
            if (components.key === 'otpGrid') {
              for (let index = 0; index < components.components.length; index++) {
                components.components[index].forEach((childComponent) => {
                  if (childComponent.key === 'card1') {
                    childComponent.disabled = true;
                  }
                });
              }
            }
          });
        }
        this.dataObj.data.components[1].components[0][0].productCard.cardTitle1Value =
              productValidationResponse.productDetails[0].productDescription;
        this.dataObj.data.components[1].components[0][0].productCard.cardText[0].cardValue =
              productValidationResponse.productDetails[0].minimumAccountOpeningBalance?.value || 0;
        this.dataObj.data.components[1].components[0][0].productCard.cardText[1].cardValue =
              productValidationResponse.productDetails[0].creditInterestRateFixed;
        this.dataObj.data.components[1].components[0][0].productCard.cardText[2].cardValue =
              productValidationResponse.productDetails[0].currencyCode;
        this.dataObj.data.components[1].components[0][0].productCard.cardText[3].cardValue =
              productValidationResponse.productDetails[0].debitInterestRateFixed;
        this.dataObj.data.components[1].components[1][0].productCard.cardTitle1Value =
              productValidationResponse.productDetails[1].productDescription;
        this.dataObj.data.components[1].components[1][0].productCard.cardText[0].cardValue =
              productValidationResponse.productDetails[1].minimumAccountOpeningBalance?.value || 0;
        this.dataObj.data.components[1].components[1][0].productCard.cardText[1].cardValue =
              productValidationResponse.productDetails[1].creditInterestRateFixed;
        this.dataObj.data.components[1].components[1][0].productCard.cardText[2].cardValue =
              productValidationResponse.productDetails[1].currencyCode;
        this.dataObj.data.components[1].components[1][0].productCard.cardText[3].cardValue =
              productValidationResponse.productDetails[1].debitInterestRateFixed;
        if (this.formInput && this.formInput.data && this.formInput.data.card && this.formInput.data.card === 'true' && this.formInput.data.card1 === 'true') {
          this.dataObj && this.dataObj.data && this.dataObj.data.components && this.dataObj.data.components.forEach((components) => {
            if (components.key === 'otpButtonsGrid') {
              for (let index = 0; index < components.components.length; index++) {
                components.components[index].forEach((childComponent) => {
                  if (childComponent.key === 'otpContinue') {
                    childComponent.disabled = true;
                  }
                });
              }
            }
          });
          this.displaySnackBar({ title: `${this.$t('messages.error')}`, content: this.$t('messages.save.oneProduct'), type: 'error' });
        } else if (this.formInput && this.formInput.data && this.formInput.data.card && (this.formInput.data.card === 'true' || this.formInput.data.card1 === 'true')) {
          this.dataObj && this.dataObj.data && this.dataObj.data.components && this.dataObj.data.components.forEach((components) => {
            if (components.key === 'otpButtonsGrid') {
              for (let index = 0; index < components.components.length; index++) {
                components.components[index].forEach((childComponent) => {
                  if (childComponent.key === 'otpContinue') {
                    childComponent.disabled = false;
                  }
                });
              }
            }
          });
        } else if (this.formInput && this.formInput.data && this.formInput.data.card && (this.formInput.data.card === 'false' ||
              this.formInput.data.card1 === 'false')) {
          this.dataObj && this.dataObj.data && this.dataObj.data.components && this.dataObj.data.components.forEach((components) => {
            if (components.key === 'otpButtonsGrid') {
              for (let index = 0; index < components.components.length; index++) {
                components.components[index].forEach((childComponent) => {
                  if (childComponent.key === 'otpContinue') {
                    childComponent.disabled = true;
                  }
                });
              }
            }
          });
        }
        const selectedProductType = this.formInput.data.card1 === 'true'
          ? JSON.parse(this.saveResponseData?.productInformation)?.productSubType
          : this.getProductType;

        if (selectedProductType && selectedProductType !== this.getProductType) {
          this.$router.replace({
            name: this.$route.name,
            params: {
              ...this.$route.params,
              productType: selectedProductType,
            },
          });
        }
        this.$forceUpdate();
      } else if (this.currentActionRoute === 'secondaryApplicantOnboard' && this.$route.query.type === 'PersonalInformation') {
        if (this.dataObj !== undefined) {
          if (this.formInput.data[this.personalInformationPage]?.addressSameAsPrimary === 'false') {
            const status = await CommonService.addressLookup(urlObj.addressLookup, {
              postCode: 'ln119hf',
              b2bSessionId: this.formInput.data.page2.b2bSessionId,
            }, false);
            store.dispatch('appStore/setAppData', {
              inProgress: false,
            });
            if (this.formInput.data[this.personalInformationPage].isAddressLookUpEnabled === 'true') {
              this.dataObj.data.wizardSteps[pageBasedOnProducts[this.getProductType][this.applicantType]?.personalInformation[0]].components.forEach((component) => {
                if (component?.key === 'addressGrid' || component?.key === 'addressDateGrid') {
                  component.hidden = false;
                  component && component.components.forEach((subComponent) => {
                    subComponent && subComponent.forEach((childComponent) => {
                      if (childComponent?.key === 'residentialAddress') {
                        childComponent.hidden = false;
                      }
                      if (childComponent?.key === 'previousResidentialAddress' || childComponent?.key === 'fromDate' || childComponent?.key === 'toDate') {
                        childComponent.hidden = !!(this.formInput.data[this.additionalInformationPage]?.addressPrevious === 'true' || this.formInput.data[this.additionalInformationPage]?.addressPrevious === true);
                      }
                    });
                  });
                }
              });
            } else if (this.formInput.data[this.personalInformationPage].isAddressLookUpEnabled === 'false') {
              this.dataObj.data.wizardSteps[pageBasedOnProducts[this.getProductType][this.applicantType]?.personalInformation[0]].components.forEach((component) => {
                if (component?.key === 'addressGrid' || component?.key === 'addressDateGrid') {
                  component.hidden = true;
                  component && component.components.forEach((subComponent) => {
                    subComponent && subComponent.forEach((childComponent) => {
                      if (childComponent?.key === 'residentialAddress') {
                        childComponent.hidden = true;
                      }
                    });
                  });
                } else if (component?.key === 'manualAddressGrid') {
                  component.hidden = false;
                  component && component.components.forEach((subComponent) => {
                    subComponent && subComponent.forEach((childComponent) => {
                      if (childComponent?.key === 'AddressLine1' || childComponent?.key === 'AddressLine2' || childComponent?.key === 'postCodeText' || childComponent?.key === 'countryText' || childComponent?.key === 'primaryManualCity' || childComponent?.key === 'stateOrProvince') {
                        childComponent.hidden = false;
                      }
                    });
                  });
                } else if (component?.key === 'manualDateGrid') {
                  component && component.components.forEach((subComponent) => {
                    subComponent && subComponent.forEach((childComponent) => {
                      if (childComponent?.key === 'addressFrom' || childComponent?.key === 'addressTo') {
                        childComponent.hidden = !!(this.formInput.data[this.personalInformationPage]?.manualPrevAddress === 'true' || this.formInput.data[this.personalInformationPage]?.addressPrevious === true);
                        component.hidden = !!(this.formInput.data[this.personalInformationPage]?.manualPrevAddress === 'true' || this.formInput.data[this.personalInformationPage]?.addressPrevious === true);
                      }
                    });
                  });
                  component && component.components.forEach((subComponent) => {
                    subComponent && subComponent.forEach((childComponent) => {
                      if (childComponent?.key === 'addressFrom' || childComponent?.key === 'addressTo') {
                        childComponent.hidden = !!(this.formInput.data[this.personalInformationPage]?.manualPrevAddress === 'true' || this.formInput.data[this.personalInformationPage]?.addressPrevious === true);
                        component.hidden = !!(this.formInput.data[this.personalInformationPage]?.manualPrevAddress === 'true' || this.formInput.data[this.personalInformationPage]?.addressPrevious === true);
                      }
                    });
                  });
                } else if (component?.key === 'primaryAddressGrid') {
                  component && component.components.forEach((subComponent) => {
                    subComponent && subComponent.forEach((childComponent) => {
                      if (childComponent?.key === 'manualAddressToggle') {
                        if (status && status.data && (status.data.isAddressLookupEnabled === false || status.data.isAddressLookupEnabled === 'false')) {
                          childComponent.disabled = true;
                        }
                      }
                    });
                  });
                }
              });
            }
          }
        }
        newVal.data[this.personalInformationPage].displayProductType = this.apiProductType.toLowerCase();
        this.formInput.data[this.personalInformationPage].productType = this.apiProductType.toLowerCase();
        this.formInput.data.page1.productTypeCode = this.apiProductType.toLowerCase();
      } else if (this.currentActionRoute === 'secondaryApplicantOnboard') {
        // Get b2bSessionId from localStorage first, then store
        const primaryApplicantDetails = localStorage.getItem('additionalInfoData') ? JSON.parse(localStorage.getItem('additionalInfoData')) : store.getters['userStore/userData'].personalInformationData ? JSON.parse(store.getters['userStore/userData'].personalInformationData) : null;
        const b2bSessionId = primaryApplicantDetails?.b2bSessionId || store?.getters['userStore/userData']?.b2bSessionId;
        const personalPage = pageBasedOnProducts?.[this.getProductType]?.secondary?.personalInformation[1] || 'page2';
        const additionalPage = pageBasedOnProducts?.[this.getProductType]?.secondary?.additionalInformation[1] || 'page3';

        this.formInput.data.page1.productSubType = this.getProductType;

        // Initialize page objects if they don't exist
        if (!this.formInput.data.page1) this.formInput.data.page1 = {};
        if (!this.formInput.data[personalPage]) this.formInput.data[personalPage] = {};
        if (!this.formInput.data[additionalPage]) this.formInput.data[additionalPage] = {};

        this.formInput.data.page1.productTypeCode = this.apiProductType.toLowerCase();
        this.formInput.data.page1.b2bSessionId = b2bSessionId;
        this.formInput.data[personalPage].b2bSessionId = b2bSessionId;
        this.formInput.data[additionalPage].b2bSessionId = b2bSessionId;
        // Also set b2bSessionId in store if not already set
        if (b2bSessionId && !store?.getters['userStore/userData']?.b2bSessionId) {
          store.dispatch('userStore/setUserData', {
            b2bSessionId: b2bSessionId,
          });
        }
        if (this.dataObj !== undefined) {
          if (newVal?.data?.page1?.mobilePhoneNumber === '' || newVal?.data?.page1?.mobilePhoneNumber === undefined || newVal?.data?.page1?.emailId === '' ||
          newVal?.data?.page1?.emailId === undefined) {
            if (newVal?.data?.page1?.mobilePhoneNumber !== '' && newVal?.data?.page1?.mobilePhoneNumber !== undefined) {
              // eslint-disable-next-line no-unused-expressions
              this.dataObj && this.dataObj.data && this.dataObj.data.wizardSteps && this.dataObj.data.wizardSteps[0]?.components.forEach((component) => {
                if (component?.key === 'grid') {
                  component && component.components.forEach((subComponent) => {
                    subComponent.forEach((childComponent) => {
                      if (childComponent?.key === 'mobilePhoneNumber') {
                        if (childComponent?.error === false) {
                          this.mobileNumberValid = true;
                        } else if (childComponent?.error === true) {
                          this.mobileNumberValid = false;
                          if (childComponent?.['error-messages'].length > 0) {
                            this.displaySnackBar({ title: this.$t('messages.error'), content: childComponent['error-messages'].join(', '), type: 'error' });
                          } else {
                            this.displaySnackBar({ title: this.$t('messages.error'), content: this.$t('messages.invalidPhoneNumber'), type: 'error' });
                          }
                          this.dataObj.data.wizardSteps[0].nextButtonHasDependentComponents = true;
                        }
                      }
                    });
                  });
                }
              });
            }
          } else {
            // eslint-disable-next-line no-unused-expressions
            this.dataObj && this.dataObj.data && this.dataObj.data.wizardSteps && this.dataObj.data.wizardSteps[0]?.components.forEach((component) => {
              if (component?.key === 'grid') {
                component && component.components.forEach((subComponent) => {
                  subComponent.forEach((childComponent) => {
                    if (childComponent?.key === 'mobilePhoneNumber') {
                      if (childComponent?.error === false) {
                        this.mobileNumberValid = true;
                      } else if (childComponent?.error === true) {
                        this.mobileNumberValid = false;
                        if (childComponent?.['error-messages'].length > 0) {
                          this.displaySnackBar({ title: this.$t('messages.error'), content: childComponent['error-messages'].join(', '), type: 'error' });
                        } else {
                          this.displaySnackBar({ title: this.$t('messages.error'), content: this.$t('messages.invalidPhoneNumber'), type: 'error' });
                        }
                        this.dataObj.data.wizardSteps[0].nextButtonHasDependentComponents = true;
                      }
                    }
                  });
                  if (this.mobileNumberValid) {
                    if (newVal?.data?.page1?.emailId === '' || newVal?.data?.page1?.emailId === undefined) {
                      this.dataObj.data.wizardSteps[0].nextButtonHasDependentComponents = true;
                    } else if (newVal?.data?.page1?.emailId !== '' || newVal?.data?.page1?.emailId !== undefined) {
                      let emailIdValidation = false;
                      // this loop is added to pick the regex pattern to validate the email from the schema.
                      subComponent.forEach((childComponent) => {
                        if (childComponent?.key === 'emailId') {
                          const emailRegexPattern = new RegExp(childComponent?.validate?.pattern);

                          if (emailRegexPattern) {
                            emailIdValidation = emailRegexPattern.test(newVal.data.page1.emailId);
                          }
                        }
                      });
                      if (!emailIdValidation) {
                        this.displaySnackBar({ title: this.$t('messages.error'), content: this.$t('messages.invalidEmailId'), type: 'error' });
                        this.dataObj.data.wizardSteps[0].nextButtonHasDependentComponents = true;
                      }
                    }
                  }
                });
              }
            });
          }
        }
        this.formInput.data[this.personalInformationPage].displayProductType = this.getProductType.toLowerCase();
        this.formInput.data[this.personalInformationPage].productType = this.apiProductType.toLowerCase();
      }
    },
    async languageDifferent(response) {
      const data = JSON.parse(localStorage.getItem('productValidationResponse'));

      if (this.formInput && this.formInput.data && this.formInput.data?.card1 === 'true') {
        const productCode = data.productDetails[1].productCode;
        if (data.productDetails[1].productSubType !== null && data.productDetails[1].productSubType !== undefined && data.productDetails[1].productSubType !== '') {
          this.resumeProductType = data.productDetails[1].productSubType;
          this.resumeProductTerm = this.getProductTerm;
        } else {
          // eslint-disable-next-line no-unused-expressions
          this.productItems?.forEach((item) => {
            if (item.code === productCode) {
              this.resumeProductType = item.type;
            }
          });
          // eslint-disable-next-line no-unused-expressions
          this.productItems?.forEach((item) => {
            if (item.code === productCode) {
              this.resumeProductTerm = item.term;
            }
          });
        }
        const applicationCode = 'fede';

        // Update route params properly using router.replace
        this.$router.replace({
          name: this.$route.name,
          params: {
            ...this.$route.params,
            applicationName: applicationCode,
            productCode: productCode,
            productType: this.resumeProductType,
            productTerm: this.resumeProductTerm,
          },
        });
      }
      this.response = this.saveResponse.data;
      let profileImage, identityDocuments;
      this.differentLanguage = false;
      const responseReceived = response !== '' && response !== undefined ? this.handleLocaleChanges(response) : false;
      if (responseReceived !== false) {
        localStorage.setItem('localeSelected', this.localeSet);
      }
      this.response.entityId = this.saveResponse.data.entityId;
      const personalInformationData = this.saveResponse.data;
      store.dispatch('userStore/setUserData', {
        personalInformationData,
      });
      const personalInformation = JSON.parse(this.saveResponse?.data?.personalInformation);
      const otherInformation = JSON.parse(this.saveResponse?.data?.otherInformation);
      const productInformation = JSON.parse(this.saveResponse?.data?.productInformation);
      const accountInformation = this.saveResponse?.data?.accountInformation !== null ? this.saveResponse?.data?.accountInformation : null;

      if (productInformation?.accountOwnership === 'JOINT') {
        if (['savings', 'termDeposit'].includes(this.getProductType) && personalInformation && personalInformation.secondaryApplicantsPersonalInformation !== undefined && personalInformation?.secondaryApplicantsPersonalInformation !== null && personalInformation?.secondaryApplicantsPersonalInformation[0]?.secondaryApplicantsEmailId !== '') {
          this.applicantType = 'secondary';
        } else {
          const employmentDetailsObject = [];
          const arrayOfEmploymentDetailsHavingData = [];
          const additionalMandatoryFields = [];
          const navMapFilename = this.navigationMapping[this.getProductType].productOnboard;

          const productOnboardSchema = await this.fetchSchema({
            mode: process.env.NODE_ENV,
            tenantID: await CommonService.getTenantId() || process.env.DEFAULT_TENANTID,
            navMapFilename,
          });
          const wizardSteps = pageBasedOnProducts[this.getProductType][this.applicantType].additionalInformation[0];
          const newDataObject = productOnboardSchema.data.wizardSteps[wizardSteps].components;

          let productListOfData = ['purposeOfAccount', 'expectedUsage'];
          newDataObject.forEach((element) => {
            if (element.key === 'employmentDetails') {
              element.components.forEach((subElement) => {
                subElement.forEach((data) => {
                  if (data.type !== 'HTMLcontent' && data?.validate?.required) {
                    employmentDetailsObject.push(data.key);
                  }
                });
              });
            }
          });
          employmentDetailsObject.forEach((element) => {
            if (otherInformation && otherInformation?.employmentDetails !== undefined && otherInformation?.employmentDetails !== null &&
        Object.keys(otherInformation.employmentDetails).includes(element) && (otherInformation.employmentDetails[element] !== '' &&
        otherInformation.employmentDetails[element] !== null)) {
              arrayOfEmploymentDetailsHavingData.push(true);
            }
          });
          newDataObject && newDataObject.forEach((component) => {
            if (component && component?.type === 'grid') {
              if (component?.components && component?.components.length > 0) {
            // eslint-disable-next-line no-unused-expressions
            component?.components.forEach((subComponent) => {
              if (subComponent && subComponent.length > 0) {
                subComponent.forEach((childComponent) => {
                  if (childComponent && childComponent?.validate && childComponent?.validate?.required) {
                    additionalMandatoryFields.push(childComponent?.key);
                  }
                });
              }
            });
              }
            }
          });
          productListOfData = additionalMandatoryFields.filter((field) => productListOfData.includes(field));
          if (productInformation && productInformation?.purposeOfAccount === 'ACCPURPOSE7') {
            productListOfData.push('purposeOfAccountOthers');
          }
          const employmentDetails = this.$appSettings.dcoConfigurations.allowedEmploymentStatusReference;

          if ((!employmentDetails.includes(otherInformation?.employmentDetails?.employmentStatus) ||
          (employmentDetails.includes(otherInformation?.employmentDetails?.employmentStatus) &&
          employmentDetailsObject.length === arrayOfEmploymentDetailsHavingData.length)) && this.checkPreFilledDataCount(productListOfData, productInformation) === 0 &&
          (['savings', 'termDeposit'].includes(this.getProductType) && (!this.$appSettings.dcoConfigurations.productsAllowedWithAccountDetails.includes(this.getProductType) ||
          (this.$appSettings.dcoConfigurations.productsAllowedWithAccountDetails.includes(this.getProductType) && accountInformation !== null &&
          this.isValueValid(accountInformation?.bankName) && this.isValueValid(accountInformation?.currency))))) {
            this.applicantType = 'secondary';
          } else {
            this.applicantType = 'primary';
          }
        }
      } else {
        this.applicantType = 'primary';
      }

      const productMapping = store?.getters['userStore/userData']?.productInfo;
      const navMapFilename = this.applicantType === 'primary' ? this.navigationMapping[this.getProductType].productOnboard : this.resumeProductType !== '' ? this.navigationMapping[this.resumeProductType].secondaryApplicantOnboard : this.navigationMapping[this.getProductType].secondaryApplicantOnboard;
      const dataObj = await this.fetchSchema({
        mode: process.env.NODE_ENV,
        tenantID: await CommonService.getTenantId() || process.env.DEFAULT_TENANTID,
        navMapFilename,
      });

      if (this.saveResponse && this.saveResponse.data && this.saveResponse.data?.applicationStatus === 'STARTED') {
        if (this.applicantType === 'secondary' && ['savings', 'termDeposit'].includes(this.getProductType)) {
          this.personalInformationPage = pageBasedOnProducts ? pageBasedOnProducts[this.getProductType][this.applicantType].personalInformation[1] : '';
          this.additionalInformationPage = pageBasedOnProducts ? pageBasedOnProducts[this.getProductType][this.applicantType].additionalInformation[1] : '';
        } else if (this.applicantType === 'secondary' && ['cashISA', 'lifetimeISA', 'noticeDeposit', 'currentAccount'].includes(this.getProductType)) {
          localStorage.setItem('additionalInfoData', JSON.stringify(this.saveResponse?.data));
          this.modalConfig.content = '';
          this.modelDataObj = response;
          this.modalConfig.close = true;
          this.modalFormCode = response?.data?.entityCode;
          this.modalConfig.title = 'secondaryApplicantChangeProduct';
          this.modalConfig.width = 510;
          this.modalConfig.rounded = true;
          this.modalConfig.hideToolbar = true;
          this.modalConfig.enableSaveButton = false;
          this.modalConfig.saveButton = this.$t(`formStaticValue.${this.modalFormCode}.save`);
          this.modalConfig.cancelButton = this.$t(`formStaticValue.${this.modalFormCode}.cancel`);
          this.modalConfig.cancelCallback = () => {
            this.modelDataObj = {};
          };
          this.modalConfig.saveCallback = () => {
            this.modelDataObj = {};
          };
          this.modalConfig.enabled = true;
          return;
        } else if (this.applicantType === 'primary' && ['savings', 'termDeposit'].includes(this.getProductType) && productInformation?.productId !== this.getProductCode && !['SOLE', 'SINGLE'].includes(productMapping?.data?.applicableAccountOperationType)) {
          localStorage.setItem('additionalInfoData', JSON.stringify(this.saveResponse?.data));
          this.modalConfig.content = '';
          this.modelDataObj = response;
          this.modalConfig.close = true;
          this.modalFormCode = response?.data?.entityCode;
          this.modalConfig.title = 'accountInformationToBeCaptured';
          this.modalConfig.width = 510;
          this.modalConfig.rounded = true;
          this.modalConfig.hideToolbar = true;
          this.modalConfig.enableSaveButton = false;
          this.modalConfig.saveButton = this.$t(`formStaticValue.${this.modalFormCode}.save`);
          this.modalConfig.cancelButton = this.$t(`formStaticValue.${this.modalFormCode}.cancel`);
          this.modalConfig.cancelCallback = () => {
            this.modelDataObj = {};
          };
          this.modalConfig.saveCallback = () => {
            this.modelDataObj = {};
          };
          this.modalConfig.enabled = true;
          return;
        } else if (this.applicantType === 'primary' && productInformation?.accountOwnership === 'JOINT' && ['cashISA', 'lifetimeISA', 'noticeDeposit', 'currentAccount'].includes(this.getProductType)) {
          localStorage.setItem('additionalInfoData', JSON.stringify(this.saveResponse?.data));
          this.modalConfig.content = '';
          this.modelDataObj = response;
          this.modalConfig.close = true;
          this.modalFormCode = response?.data?.entityCode;
          this.modalConfig.title = 'changeAccountOwnerShipState';
          this.modalConfig.width = 510;
          this.modalConfig.rounded = true;
          this.modalConfig.hideToolbar = true;
          this.modalConfig.enableSaveButton = false;
          this.modalConfig.saveButton = this.$t(`formStaticValue.${this.modalFormCode}.save`);
          this.modalConfig.cancelButton = this.$t(`formStaticValue.${this.modalFormCode}.cancel`);
          this.modalConfig.cancelCallback = () => {
            this.modelDataObj = {};
          };
          this.modalConfig.saveCallback = () => {
            this.modelDataObj = {};
          };
          this.modalConfig.enabled = true;
        }
      }
      if (this.applicantType === 'secondary') {
        const b2bSessionId = this.saveResponse?.data?.b2bSessionId;
        const primaryProfileImage = await CommonService.getDocumentUpload(`${urlObj.getUpload}/${this.saveResponse.data.entityId}/${'FECO_PROOF_CATEGORY_PHOTO'}/${'Primary'}`, { b2bSessionId: b2bSessionId });

        if (primaryProfileImage?.data?.length > 0) {
          localStorage.setItem('IDVForSecondaryApplicant', false);
          this.IDVForSecondaryApplicant = false;
        }
        profileImage = await CommonService.getDocumentUpload(`${urlObj.getUpload}/${this.saveResponse.data.entityId}/${'FECO_PROOF_CATEGORY_PHOTO'}/${'Secondary'}`, { b2bSessionId: b2bSessionId });
        identityDocuments = await CommonService.getDocumentUpload(`${urlObj.getUpload}/${this.saveResponse.data.entityId}/${'FECO_PROOF_CATEGORY_IDENTITY'}/${'Secondary'}`, { b2bSessionId: b2bSessionId });
      } else {
        const b2bSessionId = this.saveResponse?.data?.b2bSessionId;
        const applicantType = this.applicantType === 'primary' ? 'Primary' : 'Secondary';

        profileImage = await CommonService.getDocumentUpload(`${urlObj.getUpload}/${this.saveResponse.data.entityId}/${'FECO_PROOF_CATEGORY_PHOTO'}/${applicantType}`, { b2bSessionId: b2bSessionId });
        identityDocuments = await CommonService.getDocumentUpload(`${urlObj.getUpload}/${this.saveResponse.data.entityId}/${'FECO_PROOF_CATEGORY_IDENTITY'}/${applicantType}`, { b2bSessionId: b2bSessionId });
      }

      this.profileImage = profileImage;
      this.identityDocuments = identityDocuments;
      // this is needed for re-validation of LISA while switching between products.
      const transferInValidation = otherInformation && otherInformation?.lisaTransferInWithAgeValidation !== undefined && otherInformation?.lisaTransferInWithAgeValidation !== null ? otherInformation?.lisaTransferInWithAgeValidation : localStorage.getItem('isLisaTransferInWithAgeCheck');

      if (this.getProductType === 'lifetimeISA' && ((transferInValidation === true || transferInValidation === 'true') && personalInformation !== null)) {
        const [year, month, day] = personalInformation?.dateOfBirth.split('-');
        const lisaYears = new Date().getFullYear() - Number(year);

        this.lisaEligibilityPassed = lisaYears > 39 ? false : lisaYears === 39 ? Number(month) - 1 > new Date().getMonth() ? false : Number(month) - 1 === new Date().getMonth() ? !(Number(day) > new Date().getDate()) : true : true;
      } else if (this.getProductType === 'lifetimeISA' && (transferInValidation === 'false' || !transferInValidation)) {
        this.lisaEligibilityPassed = true;
      }
      const applicationStatus = ['CUSTOMER_CREATE_SUBMITTED', 'SECONDARY_CUSTOMER_CREATE_SUBMITTED', 'CUSTOMER_CREATE_SUCCESS_IDV_PENDING',
        'CUSTOMER_CREATE_SUCCESS_IDV_FAILURE', 'CUSTOMER_CREATE_SUCCESS_LISA_REJECTED', 'CUSTOMER_CREATE_SUCCESS_ACCOUNT_PROCEED',
        'CUSTOMER_CREATE_SUCCESS_SECONDARY_CUSTOMER_BLOCKED', 'SECONDARY_CUSTOMER_CREATE_SUCCESS_WITH_IDV_PENDING', 'SECONDARY_CUSTOMER_CREATE_SUCCESS_WITH_PRIMARY_IDV_PENDING',
        'PRIMARY_SECONDARY_CUSTOMER_CREATE_SUCCESS_WITH_BOTH_IDV_PENDING', 'CUSTOMER_CREATE_FAILED', 'CUSTOMER_CREATE_SUCCESS_WITH_PRIMARY_IDV_PENDING_SECONDARY_CUSTOMER_BLOCKED',
        'SECONDARY_CUSTOMER_CREATE_FAILED', 'ACCOUNT_CREATE_FAILED', 'ACCOUNT_CREATE_SUCCESS', 'IDV_PENDING_EBAV_ACCEPTED', 'IDV_PENDING_EBAV_REFERRAL', 'IDV_PENDING_EBAV_ERROR', 'CUSTOMER_CREATE_SUCCESS_EBAV_ERROR', 'CUSTOMER_CREATE_SUCCESS_EBAV_SUBMITTED', 'EBAV_ACCEPTED_NOM_ACC_SUBMITTED', 'EBAV_REFERRAL_NOM_ACC_SUBMITTED'];

      if (this.saveResponse && this.saveResponse.data && applicationStatus.includes(this.saveResponse.data.applicationStatus)) {
        const additionalInfoData = this.saveResponse.data;
        store.dispatch('userStore/setUserData', {
          additionalInfoData,
        });
        this.$router.push({ params: { action: 'ReviewInformation' } });
      } else {
        const differentProduct = this.getProductCode !== productInformation?.productId;
        const route = this.getRouteInformation(this.applicantType, dataObj, this.saveResponseData);

        if (!differentProduct) {
          if ((this.getProductType === 'savings' || this.getProductType === 'termDeposit') && route?.query === undefined && (route?.action === 'secondaryEligibilityCheck' || route?.action === 'ReviewInformation') && ['Joint', 'JOINT'].includes(productInformation?.accountOwnership) &&
        personalInformation && personalInformation.secondaryApplicantsPersonalInformation === undefined) {
            localStorage.setItem('additionalInfoData', JSON.stringify(this.saveResponse?.data));
            this.modalConfig.content = '';
            this.modelDataObj = response;
            this.modalConfig.close = true;
            this.modalFormCode = response?.data?.entityCode;
            this.modalConfig.title = 'secondaryApplicantResume';
            this.modalConfig.width = 510;
            this.modalConfig.rounded = true;
            this.modalConfig.hideToolbar = true;
            this.modalConfig.enableSaveButton = false;
            this.modalConfig.saveButton = this.$t(`formStaticValue.${this.modalFormCode}.save`);
            this.modalConfig.cancelButton = this.$t(`formStaticValue.${this.modalFormCode}.cancel`);
            this.modalConfig.cancelCallback = () => {
              this.modelDataObj = {};
            };
            this.modalConfig.saveCallback = () => {
              this.modelDataObj = {};
            };
            this.modalConfig.enabled = true;
          } else {
            if (route?.query !== undefined) {
              this.$router.push({ params: { action: route?.action }, query: route?.query });
            } else {
              this.$router.push({ params: { action: route?.action } });
            }
          }
        } else if (differentProduct) {
          let savedProductType = '';
          if (productInformation?.accountOwnership.toLowerCase() === 'joint') {
            savedProductType = productInformation?.productTypeCode === 'termdeposit' ? 'termDeposit' : 'savings';
          } else {
            if (productInformation?.productSubType !== undefined && productInformation?.productSubType !== null && productInformation?.productSubType !== '') {
              savedProductType = productInformation?.productSubType;
            } else {
              for (let i = 0; i < this.productItems.length; i++) {
                if (this.productItems[i].code === productInformation?.productId) {
                  savedProductType = this.productItems[i].type;
                }
              }
            }
          }
          if (['currentAccount', 'cashISA', 'lifetimeISA', 'noticeDeposit'].includes(this.getProductType) && ['savings', 'termDeposit'].includes(savedProductType)) {
            if (productInformation?.accountOwnership === 'SOLE' && route?.query === undefined && route?.action === 'ReviewInformation' && this.applicantType === 'primary') {
              this.modalConfig.content = '';
              this.modelDataObj = response;
              this.modalConfig.close = true;
              this.modalFormCode = response?.data?.entityCode;
              this.modalConfig.title = 'secondaryApplicantResume';
              this.modalConfig.width = 510;
              this.modalConfig.rounded = true;
              this.modalConfig.hideToolbar = true;
              this.modalConfig.enableSaveButton = false;
              this.modalConfig.saveButton = this.$t(`formStaticValue.${this.modalFormCode}.save`);
              this.modalConfig.cancelButton = this.$t(`formStaticValue.${this.modalFormCode}.cancel`);
              this.modalConfig.cancelCallback = () => {
                this.modelDataObj = {};
              };
              this.modalConfig.saveCallback = () => {
                this.modelDataObj = {};
              };
              this.modalConfig.enabled = true;
            } else if (productInformation?.accountOwnership === 'JOINT' && this.applicantType === 'secondary') {
              this.modalConfig.content = '';
              this.modelDataObj = response;
              this.modalConfig.close = true;
              this.modalFormCode = response?.data?.entityCode;
              this.modalConfig.title = 'secondaryApplicantDeleteData';
              this.modalConfig.width = 510;
              this.modalConfig.rounded = true;
              this.modalConfig.hideToolbar = true;
              this.modalConfig.enableSaveButton = false;
              this.modalConfig.saveButton = this.$t(`formStaticValue.${this.modalFormCode}.save`);
              this.modalConfig.cancelButton = this.$t(`formStaticValue.${this.modalFormCode}.cancel`);
              this.modalConfig.cancelCallback = () => {
                this.modelDataObj = {};
              };
              this.modalConfig.saveCallback = () => {
                this.modelDataObj = {};
              };
              this.modalConfig.enabled = true;
            } else if (productInformation?.accountOwnership === 'SOLE') {
              if (route?.query !== undefined) {
                this.$router.push({ params: { action: route?.action }, query: route?.query });
              } else {
                this.$router.push({ params: { action: route?.action } });
              }
            }
          } else if (['savings', 'termDeposit'].includes(this.getProductType) && (['currentAccount', 'cashISA', 'lifetimeISA', 'noticeDeposit'].includes(savedProductType) || (productMapping?.data?.applicableAccountOperationType === 'SOLE'))) {
            this.modalConfig.content = '';
            this.modelDataObj = response;
            this.modalConfig.close = true;
            this.modalFormCode = response?.data?.entityCode;
            this.modalConfig.title = 'secondaryApplicantDeleteData';
            this.modalConfig.width = 510;
            this.modalConfig.rounded = true;
            this.modalConfig.hideToolbar = true;
            this.modalConfig.enableSaveButton = false;
            this.modalConfig.saveButton = this.$t(`formStaticValue.${this.modalFormCode}.save`);
            this.modalConfig.cancelButton = this.$t(`formStaticValue.${this.modalFormCode}.cancel`);
            this.modalConfig.cancelCallback = () => {
              this.modelDataObj = {};
            };
            this.modalConfig.saveCallback = () => {
              this.modelDataObj = {};
            };
            this.modalConfig.enabled = true;
          } else {
            if (route?.query !== undefined) {
              this.$router.push({ params: { action: route?.action }, query: route?.query });
            } else {
              this.$router.push({ params: { action: route?.action } });
            }
          }
        }
      }
    },
    checkPreFilledDataCount(keys, data) {
      return keys.filter((key) => !this.isValueValid(data[key])).length;
    },
    isValueValid(value) {
      return value !== null && value !== undefined && value !== '';
    },
    validateFormFields(newVal) {
      this.dataObj.data.wizardSteps[0].components.forEach((component) => {
        if (component?.key === 'grid') {
          component.components.forEach((subComponent) => {
            // Validate mobile number
            const mobileField = subComponent.find((field) => field?.key === 'mobilePhoneNumber');

            if (mobileField) {
              this.mobileNumberValid = !mobileField.error;
              if (mobileField.error) {
                if (mobileField?.['error-messages'].length > 0) {
                  this.displaySnackBar({ title: this.$t('messages.error'), content: mobileField['error-messages'].join(', '), type: 'error' });
                } else {
                  this.displaySnackBar({ title: this.$t('messages.error'), content: this.$t('messages.invalidPhoneNumber'), type: 'error' });
                }
                this.dataObj.data.wizardSteps[0].components[3].components[0][0].disabled = true;
                return;
              }
            }

            // Validate email if mobile is valid
            if (this.mobileNumberValid) {
              const emailField = subComponent.find((field) => field?.key === 'emailId');

              if (emailField) {
                const emailRegexPattern = new RegExp(emailField.validate?.pattern);
                const isValidEmail = emailRegexPattern?.test(newVal.data.page1.emailId);

                this.dataObj.data.wizardSteps[0].components[3].components[0][0].disabled = !isValidEmail;

                if (!isValidEmail) {
                  this.displaySnackBar({
                    title: this.$t('messages.error'),
                    content: this.$t('messages.invalidEmailId'),
                    type: 'error',
                  });
                }
              }
            }
          });
        }
      });
    },
  },
};

export default formDataMixin;
